import React, { Component } from "react";
import { Card, Row, Col, Button, Modal, Form, Table, Alert } from 'react-bootstrap';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import api from "../../services/api";
import { formatarValor, formatarValorLocal, formataDataHoraExibicao, formatarValorAPI, mensagemAlerta, validaCPF, statusExame, statusExamesSelecionados, situacoesAgendamento, getDataAtualLocalISO, hasPerm, isLaudoBloqueadoParaUsuarioAtual, isDadosConfirmacaoBloqueadosParaUsuarioAtual } from '../../common/utils';
import { Accordion } from 'react-bootstrap';
import { FaFileAlt, FaInfoCircle, FaUpload, FaBan, FaExclamationTriangle, FaCloudDownloadAlt, FaDownload, FaWhatsapp } from "react-icons/fa";
import axios from 'axios';
import { getCurrentUser } from '../../common/utils';
import { getConfig } from "../../common/config";
import moment from "moment-timezone";

class ExamesComponent extends Component {
    constructor(props) {
        super(props);
        this.fileInputExameUpload = React.createRef();
        this.fileInputComprovante = React.createRef();
        this.fileInputNotaFiscal = React.createRef();
        this.state = {
            showModalExame: false,
            exames: [],
            statusOptions: [],
            motivoOptions: [],
            statusOptionsExame: [],
            loading: false,
            atendimento_id: props.atendimento_id,
            programa_id: props.programa_id,
            medico_logado_id: props.medico_logado_id,
            programa_dados: props.programa_dados || [],
            paciente_dados: props.paciente_dados || [],
            beneficiario_id: props.beneficiario_id,
            programa_configuracoes: props.programa_configuracoes || {},
            loadingExameSolicitado: {},
            exame_selecionado: {
                id: null,
                atendimento_id: null,
                medico_id: props.medico_atendimento_id || null,
                medico_nome: props.medico_atendimento_dados ? props.medico_atendimento_dados.nome : null,
                medico_crm: props.medico_atendimento_dados ? `${props.medico_atendimento_dados.registro}/${props.medico_atendimento_dados.registro_uf}` : null,
                status: null,
                data_recusa: null,
                motivo_recusa: null,
                resultado: null,
                data_recebimento: null,
                data_aprovacao: null,
                data_agendamento: null,
                data_agendada: null,
                data_realizacao: null,
                data_cancelamento: null,
                motivo: null,
                motivo_outros: '',
                arquivo_motorista_comprovante: null,
                arquivo_motorista_nota_fiscal: null,
                arquivo_motorista_comprovante_upload: null,
                arquivo_motorista_nota_fiscal_upload: null,
                exames_solicitados: [],
                arquivos_pedidos: [],
                status_salvo: null,
            },
            showModalPreSolicitacao: false,
            pre_arquivo_upload: null,
            pre_examesSelecionados: new Set(),
            listaExamesDisponiveis: [],
            possuiKit: 'sim', // 'sim' | 'nao'
            novoEndereco: {
                nome: '',
                cep: '',
                endereco: '',
                numero: '',
                complemento: '',
                bairro: '',
                cidade: '',
                uf: '',
            },
            respostasPorServico: {
                // [servico_procedimento_id]: { [question_id]: value }
            },
            arquivosDinamicos: {
                // [servico_id_question_id]: File
            },
            validacaoErros: {}, // { [question_id]: 'mensagem' }
            consultoresPorEstado: {},
        }
        this.motivos_exames = [
            { value: "diagnostico", label: "Diagnóstico" },
            { value: "entrada_medicacao", label: "Entrada para acesso a medicação" },
            { value: "renovacao_documentacao", label: "Renovação de documentação" },
            { value: "acompanhamento_patologia", label: "Acompanhamento da patologia" },
            { value: "reinicio_tratamento", label: "Reinício de tratamento" }
        ];

        this.status_obrigatorio_pagamento = ['aprovado', 'agendado', 'reagendado', 'realizado', 'cancelado', 'recusado', 'stand_by'];

        this.ufOptions = {
            "AC": "Acre",
            "AL": "Alagoas",
            "AP": "Amapá",
            "AM": "Amazonas",
            "BA": "Bahia",
            "CE": "Ceará",
            "DF": "Distrito Federal",
            "ES": "Espírito Santo",
            "GO": "Goiás",
            "MA": "Maranhão",
            "MT": "Mato Grosso",
            "MS": "Mato Grosso do Sul",
            "MG": "Minas Gerais",
            "PA": "Pará",
            "PB": "Paraíba",
            "PR": "Paraná",
            "PE": "Pernambuco",
            "PI": "Piauí",
            "RJ": "Rio de Janeiro",
            "RN": "Rio Grande do Norte",
            "RS": "Rio Grande do Sul",
            "RO": "Rondônia",
            "RR": "Roraima",
            "SC": "Santa Catarina",
            "SP": "São Paulo",
            "SE": "Sergipe",
            "TO": "Tocantins"
        };
    }

    componentDidMount() {
        if (this.props.modoCadastro) {
            // Modo inline na criação do atendimento: carrega só a lista de exames disponíveis
            // (não depende de atendimento_id) e avalia elegibilidade em memória.
            this.carregarListaExamesDisponiveisCadastro();
            return;
        }

        this.setState({ loading: true });
        this.getExames();
        this.carregaStatusMotivos();

        if (this.props.autoSolicitarExames) {
            this.novoPedidoExameMedico();
            if (this.props.onAutoSolicitarDone) {
                this.props.onAutoSolicitarDone();
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.programa_id !== this.state.programa_id) {
            this.carregaStatusMotivos(this.state.programa_id);
        }
        const prevStatusMotivos = prevState.exame_selecionado && prevState.exame_selecionado.programa_id;
        const curStatusMotivos = this.state.exame_selecionado && this.state.exame_selecionado.programa_id;
        if (prevStatusMotivos !== curStatusMotivos) {
            this.carregaStatusMotivos(curStatusMotivos || this.state.programa_id);
        }

        if (prevState.programa_id !== this.state.programa_id) {
            this.carregaStatusExames(this.state.programa_id);
        }

        // quando autoSolicitarExames mudar de false → true
        if (this.props.autoSolicitarExames && !prevProps.autoSolicitarExames) {
            this.novoPedidoExameMedico();
            // avisa o pai que já disparou, para resetar o gatilho
            if (this.props.onAutoSolicitarDone) {
                this.props.onAutoSolicitarDone();
            }
        }

        // Modo cadastro: ao TROCAR a doença na mesma tela, recarrega a lista de exames e zera a
        // seleção/respostas/arquivo anteriores. Sem isso, a tela continua exibindo os exames e o
        // questionário da doença selecionada antes.
        if (this.props.modoCadastro && prevProps.doenca_id !== this.props.doenca_id) {
            this.setState({
                pre_examesSelecionados: new Set(),
                respostasPorServico: {},
                arquivosDinamicos: {},
                validacaoErros: {},
                pre_arquivo_upload: null,
            }, () => {
                this.carregarListaExamesDisponiveisCadastro();
                this.notificarElegibilidadeCadastro();
            });
        }

        // Modo inline: avisa o pai sobre a elegibilidade ao vivo quando seleção/respostas/arquivo mudam
        if (this.props.modoCadastro && (
            prevState.pre_examesSelecionados !== this.state.pre_examesSelecionados ||
            prevState.respostasPorServico !== this.state.respostasPorServico ||
            prevState.pre_arquivo_upload !== this.state.pre_arquivo_upload
        )) {
            this.notificarElegibilidadeCadastro();
        }
    }

    getExames() {
        this.setState({ loading: true });

        let url = `/exames/?atendimento_id=${this.state.atendimento_id}`;

        if(this.state.medico_logado_id) {
            url += `&medico_id=${this.state.medico_logado_id}`;
        }

        api.get(url)
            .then(response => {
                this.setState({ exames: response.data }, () => {
                    this.carregarConsultores();
                });
                this.setState({ loading: false });
            })
            .catch(error => {
                console.error('Erro ao carregar exames:', error);
                //Sentry.captureException('Erro ao carregar exames:', error);

                let erro_msg = 'Erro ao carregar exames, tente novamente';

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }
            });
    }

    // Função auxiliar para obter configurações de exames do programa
    getConfigExames = (key, defaultValue = null) => {
        return getConfig(this.state.programa_configuracoes, `exames.${key}`, defaultValue);
    };

    // Busca dados atualizados de um exame solicitado ao abrir o accordion
    buscarDadosExameSolicitado = async (exameId, index) => {
        // Define loading para este exame específico
        this.setState(prevState => ({
            loadingExameSolicitado: {
                ...prevState.loadingExameSolicitado,
                [exameId]: true
            }
        }));

        try {
            const response = await api.get(`/exames/solicitados/${exameId}/`);
            const dadosAtualizados = response.data;

            // Atualiza o exame no array de exames_solicitados
            this.setState(prevState => ({
                exame_selecionado: {
                    ...prevState.exame_selecionado,
                    exames_solicitados: prevState.exame_selecionado.exames_solicitados.map((exame, i) =>
                        i === index ? {
                            ...exame,
                            ...dadosAtualizados,
                            servico_procedimento_nome: dadosAtualizados.dados_servico_procedimento?.nome || exame.servico_procedimento_nome,
                            laboratorio_nome: dadosAtualizados.dados_laboratorio?.nome_com_endereco || dadosAtualizados.dados_laboratorio?.nome || exame.laboratorio_nome,
                            motorista_nome: dadosAtualizados.dados_motorista?.nome || exame.motorista_nome,
                            dados_agendamento: dadosAtualizados.dados_agendamento || null,
                            status_salvo: dadosAtualizados.status,
                            focusMotorista: false,
                            focusLaboratorio: false,
                            focusProvedor: false
                        } : exame
                    )
                },
                loadingExameSolicitado: {
                    ...prevState.loadingExameSolicitado,
                    [exameId]: false
                }
            }));
        } catch (error) {
            console.error('Erro ao buscar dados do exame solicitado:', error);
            this.setState(prevState => ({
                loadingExameSolicitado: {
                    ...prevState.loadingExameSolicitado,
                    [exameId]: false
                }
            }));
        }
    };

    // Cria agendamento para o exame quando status muda para "iniciado"
    criarAgendamentoParaExame = async (exame, index) => {
        // Verifica se já tem agendamento
        if (exame.dados_agendamento && Object.keys(exame.dados_agendamento).length > 0) {
            return;
        }

        // Verifica se tem os dados necessários
        if (!exame.servico_procedimento_id || !exame.laboratorio_id) {
            mensagemAlerta('Preencha o laboratório antes de iniciar o exame', 'warning');
            return false;
        }

        const formData = new FormData();
        formData.append('servico_procedimento_id', exame.servico_procedimento_id);
        formData.append('prestador_id', exame.laboratorio_id);
        formData.append('valor', exame.valor || 0);
        formData.append('status', 'liberado');
        formData.append('data_agendamento', getDataAtualLocalISO());
        formData.append('exame_solicitado', exame.id);
        formData.append('atendimento_id', this.state.atendimento_id);
        formData.append('beneficiario_id', this.state.beneficiario_id);

        try {
            const response = await api.post('/agendamentos/', formData);
            
            // Atualiza o exame com os dados do agendamento
            this.setState(prevState => ({
                exame_selecionado: {
                    ...prevState.exame_selecionado,
                    exames_solicitados: prevState.exame_selecionado.exames_solicitados.map((ex, i) =>
                        i === index ? {
                            ...ex,
                            dados_agendamento: response.data
                        } : ex
                    )
                }
            }));
            
            return true;
        } catch (error) {
            console.error('Erro ao criar agendamento:', error);
            mensagemAlerta('Erro ao criar agendamento para o exame', 'error');
            return false;
        }
    };

    // Carrega os serviços de transporte (logística) do programa
    carregarServicosTransporte = async (inputValue) => {
        try {
            const url = `/programas/servicos_procedimentos/?servico_procedimento=${inputValue || ''}&status=1&programa=${this.state.programa_id}`;
            const response = await api.get(url);
            return (response.data.results || [])
                .filter(item => item.dados_servico?.servico_logistica)
                .map(item => ({
                    value: item.servico_procedimento_id,
                    label: `${item.dados_servico.nome} (#${item.servico_procedimento_id})`,
                    valor: formatarValor(item.valor)
                }));
        } catch (error) {
            console.error('Erro ao carregar serviços de transporte:', error);
            return [];
        }
    };

    // Gera (em 1 clique) um agendamento de transporte já finalizado e o serviço de faturamento
    /**
     * Quando já existe um agendamento do mesmo serviço sem exame vinculado, pergunta se é
     * para aproveitá-lo. Antes o backend adotava em silêncio, e quem cadastrava o exame não
     * ficava sabendo. Devolve true/false ou null quando não há o que perguntar.
     */
    perguntarVinculoAgendamentoExistente = async (servico_procedimento_id, servico_nome) => {
        if (!this.getConfigExames('sync_exame_agendamento', false)) return null;

        let candidatos = [];
        try {
            const { data } = await api.get('/agendamentos/', {
                params: {
                    atendimento_id: this.state.atendimento_id,
                    servico_procedimento_id,
                    limit: 50,
                },
            });
            const lista = data.results || (Array.isArray(data) ? data : []);
            candidatos = lista.filter(ag => !ag.exame_solicitado && !['cancelado', 'finalizado'].includes(ag.situacao));
        } catch (e) {
            //sem a consulta não dá para perguntar; segue o comportamento automático
            console.warn('Não foi possível verificar agendamentos existentes do serviço:', e);
            return null;
        }

        if (!candidatos.length) return null;

        const MySwal = withReactContent(Swal);
        const lista = candidatos.slice(0, 5).map(ag => {
            const quando = ag.data_agendamento && !String(ag.data_agendamento).startsWith('1900-01-01')
                ? formataDataHoraExibicao(ag.data_agendamento) : 'sem data';
            return `<li>#${ag.id} — ${quando}${ag.dados_prestador?.nome ? ` · ${ag.dados_prestador.nome}` : ''}</li>`;
        }).join('');

        const resposta = await MySwal.fire({
            icon: 'question',
            title: 'Já existe agendamento deste serviço',
            html: `<p style="text-align:left">Há ${candidatos.length === 1 ? 'um agendamento' : `${candidatos.length} agendamentos`} de
                   <strong>${servico_nome || 'este serviço'}</strong> ainda sem exame vinculado:</p>
                   <ul style="text-align:left">${lista}</ul>
                   <p style="text-align:left">Deseja vincular o exame a ele? Se preferir, um novo agendamento é criado.</p>`,
            showCancelButton: true,
            confirmButtonText: 'Vincular ao existente',
            cancelButtonText: 'Criar um novo',
            confirmButtonColor: '#28a745',
            reverseButtons: true,
            allowOutsideClick: false,
        });

        //fechar no X não é resposta: mantém o automático
        if (resposta.isDismissed && resposta.dismiss === Swal.DismissReason.close) return null;

        return resposta.isConfirmed;
    };

    gerarAgendamentoTransporte = async (exame, index) => {
        const MySwal = withReactContent(Swal);

        if (!exame.motorista_id || exame.motorista_id === 'outro') {
            mensagemAlerta('Selecione o responsável pelo transporte (prestador cadastrado) antes de gerar o transporte.', 'warning');
            return;
        }
        if (!exame.servico_transporte_id) {
            mensagemAlerta('Selecione o serviço de transporte.', 'warning');
            return;
        }
        if (!exame.motorista_orcamento) {
            mensagemAlerta('Informe o valor do transporte.', 'warning');
            return;
        }

        //Ida e volta viram dois agendamentos: cada trecho e faturado no seu proprio valor.
        //O vinculo com o exame vai em exame_logistica / exame_logistica_2, nunca no
        //exame_solicitado, que finalizaria o proprio exame junto com o transporte.
        const transporteIdaVolta = this.getConfigExames('transporte_ida_volta', false);
        const temVolta = transporteIdaVolta && !!exame.motorista_orcamento_volta;

        const trechos = [{ rotulo: 'ida', valor: exame.motorista_orcamento, campo: 'exame_logistica_id' }];
        if (temVolta) {
            trechos.push({ rotulo: 'volta', valor: exame.motorista_orcamento_volta, campo: 'exame_logistica_2_id' });
        }

        //A volta costuma ser combinada depois da ida. Como o botao e o mesmo, o trecho que ja
        //tem agendamento ativo e pulado — senao gerar a volta duplicaria a ida. Trecho
        //cancelado nao conta: ali a intencao e realmente refazer.
        const jaGerados = (exame.dados_agendamentos_transporte || [])
            .filter(t => t.situacao !== 'cancelado')
            .map(t => t.trecho);
        const pendentes = trechos.filter(t => !jaGerados.includes(t.rotulo));

        if (pendentes.length === 0) {
            mensagemAlerta('Os transportes deste exame já foram gerados. Para refazer, cancele o agendamento correspondente.', 'warning');
            return;
        }

        const resumo = pendentes.map(t => `${t.rotulo}: <strong>${t.valor}</strong>`).join(' &middot; ');

        const confirm = await MySwal.fire({
            icon: 'question',
            title: pendentes.length > 1 ? 'Gerar transporte (ida e volta)' : `Gerar transporte (${pendentes[0].rotulo})`,
            html: `Gerar agendamento do transporte <strong>${exame.servico_transporte_nome || ''}</strong> — ${resumo}?<br /><br /><small class="text-muted">${pendentes.length > 1 ? 'Serão criados dois agendamentos, um por trecho, como Liberado. ' : 'O agendamento será criado como Liberado. '}O faturamento é gerado na confirmação da realização.</small>`,
            showCancelButton: true,
            confirmButtonText: 'Sim, gerar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#28a745',
        });
        if (!confirm.isConfirmed) return;

        const montaFormData = (trecho) => {
            const formData = new FormData();
            formData.append('servico_procedimento_id', exame.servico_transporte_id);
            formData.append('prestador_id', exame.motorista_id);
            formData.append('valor', formatarValorAPI(trecho.valor ?? 0));
            formData.append(trecho.campo, exame.id);
            formData.append('atendimento_id', this.state.atendimento_id);
            formData.append('beneficiario_id', this.state.beneficiario_id);
            formData.append('programa_id', this.state.programa_id);
            //Transporte nasce Liberado, nao Finalizado: a corrida ainda vai acontecer. O
            //faturamento sai da confirmacao da realizacao, como em qualquer outro servico,
            //senao a plataforma fatura o motorista antes de ele rodar.
            formData.append('situacao', 'liberado');
            formData.append('data_agendamento', exame.dados_agendamento?.data_agendamento || getDataAtualLocalISO());
            formData.append('anotacoes', `Transporte (${trecho.rotulo}) do exame #${exame.id}`);
            return formData;
        };

        MySwal.fire({
            title: 'Aguarde...',
            text: 'Gerando transporte',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => { MySwal.showLoading(); }
        });

        try {
            //Grava responsavel e valores no exame antes de gerar. Eles so existiam no estado
            //da tela: apos o refresh a secao de transporte voltava vazia, porque ela depende
            //de motorista_id, e os valores digitados se perdiam.
            const dadosTransporte = new FormData();
            dadosTransporte.append('necessita_motorista', true);
            dadosTransporte.append('motorista_id', exame.motorista_id);
            dadosTransporte.append('motorista_orcamento', formatarValorAPI(exame.motorista_orcamento ?? 0));
            if (exame.motorista_orcamento_volta) {
                dadosTransporte.append('motorista_orcamento_volta', formatarValorAPI(exame.motorista_orcamento_volta));
            }
            await api.put(`/exames/solicitados/${exame.id}/`, dadosTransporte);

            //em sequencia, e nao em paralelo: se a volta falhar, a ida ja esta registrada e
            //a mensagem de erro nao deixa duvida sobre o que foi gerado
            for (const trecho of pendentes) {
                await api.post('/agendamentos/', montaFormData(trecho));
            }
            // Limpa a seleção do serviço para permitir gerar outro transporte
            this.setState(prevState => ({
                exame_selecionado: {
                    ...prevState.exame_selecionado,
                    exames_solicitados: prevState.exame_selecionado.exames_solicitados.map((ex, i) =>
                        i === index ? { ...ex, servico_transporte_id: null, servico_transporte_nome: null } : ex
                    )
                }
            }));
            await this.buscarDadosExameSolicitado(exame.id, index);
            MySwal.fire({
                icon: 'success',
                title: 'Sucesso!',
                text: pendentes.length > 1
                    ? 'Transportes de ida e volta gerados como Liberado.'
                    : `Transporte (${pendentes[0].rotulo}) gerado como Liberado.`,
                timer: 2000,
                showConfirmButton: false
            });
        } catch (error) {
            console.error('Erro ao gerar transporte:', error);
            MySwal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Erro ao gerar o transporte. Tente novamente.',
                confirmButtonColor: '#3085d6',
            });
        }
    };

    /**
     * O transporte pode ser acompanhado tanto pelas abas de Agendamentos quanto por aqui.
     * As duas telas gravam no mesmo agendamento, então o status fica sincronizado sem
     * cópia de estado: confirmar por aqui é o mesmo que confirmar lá.
     */
    alterarSituacaoTransporte = async (transporte, exame, index, situacao) => {
        const MySwal = withReactContent(Swal);
        const confirmar = situacao === 'finalizado';

        const confirm = await MySwal.fire({
            icon: 'question',
            title: confirmar ? 'Confirmar realização do transporte' : 'Cancelar transporte',
            html: confirmar
                ? `Confirmar a realização do transporte <strong>#${transporte.id}</strong> no valor de <strong>${formatarValorLocal(transporte.valor)}</strong>?<br /><br /><small class="text-muted">O serviço de faturamento será gerado agora.</small>`
                : `Cancelar o transporte <strong>#${transporte.id}</strong>?`,
            showCancelButton: true,
            confirmButtonText: confirmar ? 'Sim, confirmar' : 'Sim, cancelar',
            cancelButtonText: 'Voltar',
            confirmButtonColor: confirmar ? '#28a745' : '#d33',
        });
        if (!confirm.isConfirmed) return;

        MySwal.fire({
            title: 'Aguarde...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => { MySwal.showLoading(); }
        });

        try {
            const formData = new FormData();
            formData.append('situacao', situacao);
            if (confirmar) {
                formData.append('data_realizacao', getDataAtualLocalISO());
                formData.append('adicionar_servico_atendimento', true);
            } else {
                formData.append('data_cancelamento', getDataAtualLocalISO());
            }
            await api.put(`/agendamentos/${transporte.id}/`, formData);
            await this.buscarDadosExameSolicitado(exame.id, index);
            MySwal.fire({
                icon: 'success',
                title: 'Sucesso!',
                text: confirmar ? 'Transporte confirmado e faturamento gerado.' : 'Transporte cancelado.',
                timer: 2000,
                showConfirmButton: false
            });
        } catch (error) {
            console.error('Erro ao atualizar transporte:', error);
            MySwal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Não foi possível atualizar o transporte. Tente novamente.',
                confirmButtonColor: '#3085d6',
            });
        }
    };

    // Handler para quando o accordion é selecionado
    handleAccordionSelect = (eventKey, exame, index) => {
        if (eventKey && exame.id) {
            this.buscarDadosExameSolicitado(exame.id, index);
        }
    };

    excluirExameSolicitado = (exame_selecionado, examesFiltrados) => {
        const MySwal = withReactContent(Swal);
        const url = '/exames/solicitados/' + exame_selecionado.id + '/'

        // Fase B: avisa quando há agendamento vinculado, que também será excluído/cancelado.
        const agendamentoVinculado = exame_selecionado.dados_agendamento;
        let textoConfirmacao = 'Tem certeza que deseja excluir o exame ' + exame_selecionado.servico_procedimento_nome + '?';
        if (agendamentoVinculado && agendamentoVinculado.id) {
            textoConfirmacao += ' Este exame possui um agendamento vinculado (#' + agendamentoVinculado.id + ') que também será excluído/cancelado.';
        }

        MySwal.fire({
            icon: 'warning',
            title: 'Atenção!',
            text: textoConfirmacao,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Sim',
            showCancelButton: true,
            cancelButtonColor: '#d33',
            cancelButtonText: 'Não'
        }).then(async (result) => {
            if (result.isConfirmed) {
                api({
                    method: 'delete',
                    url: url
                })
                .then(response => {
                    mensagemAlerta('Exame excluído com sucesso!', 'success');
                    const examesAtualizados = this.state.exame_selecionado.exames_solicitados.filter(
                        exame => exame.id !== exame_selecionado.id
                    );
                    this.setState(prev => ({
                        exame_selecionado: {
                            ...prev.exame_selecionado,
                            exames_solicitados: examesAtualizados
                        }
                    }), () => {
                        this.getExames();
                    });
                })
                .catch(error => {
                    mensagemAlerta('Erro ao excluir exame solicitado!', 'error');
                    console.error('Erro ao excluir exame solicitado:', error);
                });
            }
        });
    }
    
    
    upsertExameSolicitado = async (exame_selecionado) => {
        const MySwal = withReactContent(Swal);
        const url = (exame_selecionado.id) ? '/exames/solicitados/' + exame_selecionado.id + '/' : '/exames/solicitados/'
        const metodo = (exame_selecionado.id) ? 'put' : 'post'
        const formData = new FormData();
        let statusParaEnviar = exame_selecionado.status;

        //só na criação: havendo agendamento do mesmo serviço ainda sem exame, quem decide se
        //aproveita ou cria outro é a operação, não o sistema
        let vincularAgendamento = null;
        if (!exame_selecionado.id) {
            vincularAgendamento = await this.perguntarVinculoAgendamentoExistente(
                exame_selecionado.servico_procedimento_id,
                exame_selecionado.servico_procedimento_nome,
            );
        }

        // Obtém configurações do programa
        const ocultarDataAgendamento = this.getConfigExames('ocultar_data_agendamento', false);
        const ocultarDataAgendada = this.getConfigExames('ocultar_data_agendada', false);
        const dataRealizacaoObrigatoria = this.getConfigExames('data_realizacao_obrigatoria', false);
        const ocultarHoraDatas = this.getConfigExames('ocultar_hora_datas', false);

        // Função para formatar data para envio à API
        const formatarDataParaAPI = (valor) => {
            if (!valor) return '';
            // Se ocultar hora e o valor não tem hora (formato YYYY-MM-DD), adiciona T00:00:00
            if (ocultarHoraDatas && valor.length === 10) {
                return valor + 'T00:00:00';
            }
            return valor;
        };

        const configuracoes = this.props.programa_dados?.configuracoes || {};
        const configExames = configuracoes['Exames_Component'] || {};
        
        //Cuidado com a pegadinha (definiram os nomes trocados, n altera só aceita)
        // Label: "Data de Agendamento" -> Input name: data_agendada -> Key: data_de_agendamento
        const dataDeAgendamentoHabilitado = configExames['data_de_agendamento']?.includes('habilitado');
        const dataDeAgendamentoObrigatorio = configExames['data_de_agendamento']?.includes('obrigatorio');
        
        // Label: "Data Agendada" -> Input name: data_agendamento -> Key: data_agendada
        const dataAgendadaObrigatorio = configExames['data_agendada']?.includes('obrigatorio');

        if(exame_selecionado.id) {
            // Liberação de elegibilidade pela navegadora ("Este caso não seguirá o fluxo padrão de elegibilidade"):
            // exige Motivo e devolve o pedido ao fluxo normal (aguardando aprovação).
            if (exame_selecionado.liberar_elegibilidade) {
                if (!exame_selecionado.motivo_status || exame_selecionado.motivo_status.trim().length < 10) {
                    mensagemAlerta('Informe o motivo da liberação da elegibilidade (mínimo 10 caracteres).', 'warning');
                    return;
                }
                statusParaEnviar = 'aguardando_aprovacao';
            }

            if(exame_selecionado.necessita_motorista && exame_selecionado.motorista_id == 'outro') {
                if(!exame_selecionado.novo_motorista_nome || !exame_selecionado.novo_motorista_cpf || !exame_selecionado.motorista_contato) {
                    mensagemAlerta('Preencha todos os dados obrigatórios do transporte!', 'warning');
                    return;
                }
                formData.append('novo_motorista_nome', exame_selecionado.novo_motorista_nome ?? '');
                if(!validaCPF(exame_selecionado.novo_motorista_cpf)) {
                    mensagemAlerta('CPF inválido!', 'warning');
                    return;
                } else {
                    formData.append('novo_motorista_cpf', exame_selecionado.novo_motorista_cpf ?? '');
                }
            }


            if(exame_selecionado.status === 'recusado' || exame_selecionado.status === 'cancelado' || exame_selecionado.status === 'stand_by') {
                if(!exame_selecionado.motivo_status || exame_selecionado.motivo_status.length < 30) {
                    mensagemAlerta('Preencha o motivo do status com no minimo 30 caracteres!', 'warning');
                    return;
                }
            }

            // Validação de data_agendamento e data_agendada
            // Cada campo valida apenas se: estiver visível (!ocultar) E for obrigatório
            if(exame_selecionado.status === 'agendado' || exame_selecionado.status === 'reagendado') {
                // Valida "Data Agendada" (input name: data_agendamento) se visível E obrigatório
                if(!ocultarDataAgendada && dataAgendadaObrigatorio && !exame_selecionado.data_agendamento) {
                        mensagemAlerta('O campo Data Agendada é obrigatório!', 'warning');
                        return;
                }

                // Valida "Data de Agendamento" (input name: data_agendada) se visível E obrigatório
                if(!ocultarDataAgendamento && dataDeAgendamentoObrigatorio && !exame_selecionado.data_agendada) {
                        mensagemAlerta('O campo Data de Agendamento é obrigatório!', 'warning');
                        return;
                }
            }
            if(exame_selecionado.status === 'aprovado') {
                if(!exame_selecionado.data_aprovacao) {
                    mensagemAlerta('Preencha a data de aprovação', 'warning');
                    return;
                }
            }
            // Validação de data_realizacao quando configurado como obrigatório
            if (dataRealizacaoObrigatoria && (exame_selecionado.status === 'realizado' || exame_selecionado.status === 'concluido')) {
                if (!exame_selecionado.data_realizacao) {
                    mensagemAlerta('Preencha a data de realização', 'warning');
                    return;
                }
            }
        }

        formData.append('atendimento_id', this.state.atendimento_id ?? '');
        formData.append('exame_id', this.state.exame_selecionado.id ?? '');
        formData.append('servico_procedimento_id', exame_selecionado.servico_procedimento_id ?? '');
        if (vincularAgendamento !== null) formData.append('vincular_agendamento_existente', vincularAgendamento);
        formData.append('necessita_motorista', exame_selecionado.necessita_motorista || false );
        formData.append('provedor_credenciado', true );
        if (exame_selecionado.id) {
            formData.append('status', statusParaEnviar ?? '');
            if(exame_selecionado.status === 'recusado' || exame_selecionado.status === 'cancelado' || exame_selecionado.status === 'stand_by') {
                formData.append('motivo_status', exame_selecionado.motivo_status ?? '');
            }
            if(exame_selecionado.motorista_id) {
                formData.append('motorista_id', exame_selecionado.motorista_id ?? '');
            }
            if(exame_selecionado.laboratorio_id) {
                formData.append('laboratorio_id', exame_selecionado.laboratorio_id ?? '');
            }
            if (exame_selecionado.data_realizacao) {
                formData.append('data_realizacao', formatarDataParaAPI(exame_selecionado.data_realizacao));
            }
            if (exame_selecionado.data_agendamento) {
                formData.append('data_agendamento', formatarDataParaAPI(exame_selecionado.data_agendamento));
            }
            if (exame_selecionado.data_agendada) {
                formData.append('data_agendada', formatarDataParaAPI(exame_selecionado.data_agendada));
            }
            if (exame_selecionado.data_aprovacao) {
                formData.append('data_aprovacao', formatarDataParaAPI(exame_selecionado.data_aprovacao));
            }
            if (exame_selecionado.data_cancelamento) {
                formData.append('data_cancelamento', formatarDataParaAPI(exame_selecionado.data_cancelamento));
            }
            if (exame_selecionado.motivo_status) {
                formData.append('motivo_status', exame_selecionado.motivo_status ?? '');
            }
            if (exame_selecionado.arquivo_comprovante_upload) {
                formData.append('arquivo_comprovante', exame_selecionado.arquivo_comprovante_upload ?? '');
            }
            if (exame_selecionado.arquivo_motorista_comprovante_upload) {
                formData.append('arquivo_motorista_comprovante', exame_selecionado.arquivo_motorista_comprovante_upload ?? '');
            }
            if (exame_selecionado.arquivo_motorista_nota_fiscal_upload) {
                formData.append('arquivo_motorista_nota_fiscal', exame_selecionado.arquivo_motorista_nota_fiscal_upload ?? '');
            }
            if (exame_selecionado.arquivo_nota_fiscal_upload) {
                formData.append('arquivo_nota_fiscal', exame_selecionado.arquivo_nota_fiscal_upload ?? '');
            }
            if (exame_selecionado.motorista_orcamento) {
                formData.append('motorista_orcamento', formatarValorAPI(exame_selecionado.motorista_orcamento ?? 0));
            }
            if (exame_selecionado.motorista_orcamento_volta) {
                formData.append('motorista_orcamento_volta', formatarValorAPI(exame_selecionado.motorista_orcamento_volta ?? 0));
            }
            if (exame_selecionado.motorista_contato) {
                formData.append('motorista_contato', exame_selecionado.motorista_contato ?? '');
            }
            if (exame_selecionado.motorista_data_aprovacao) {
                formData.append('motorista_data_aprovacao', exame_selecionado.motorista_data_aprovacao ?? '');
            }
        }

        // Exibe loading
        MySwal.fire({
            title: 'Aguarde...',
            text: 'Atualizando exame',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                MySwal.showLoading();
            }
        });

        if(metodo === 'post' && this.state.medico_logado_id) {
            formData.append('status', 'aguardando_aprovacao');
        }

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData
        })
        .then(async response => {
            const exameInserido = {
                id: response.data.id,
                exame_id: response.data.exame_id,
                servico_procedimento_id: response.data.servico_procedimento_id,
                servico_procedimento_nome: response.data.dados_servico_procedimento.nome,
                necessita_motorista: response.data.necessita_motorista,
                laboratorio_id: response.data.laboratorio_id,
                laboratorio_nome: response.data.dados_laboratorio.nome_com_endereco ?? response.data.dados_laboratorio.nome,
                data_criacao: response.data.data_criacao,
                arquivo_comprovante: response.data.arquivo_comprovante,
                arquivo_nota_fiscal: response.data.arquivo_nota_fiscal,
                arquivo_motorista_comprovante: response.data.arquivo_motorista_comprovante,
                arquivo_motorista_nota_fiscal: response.data.arquivo_motorista_nota_fiscal,
                motorista_id: response.data.motorista_id,
                motorista_nome: response.data.dados_motorista.nome,
                valor: response.data.valor,
                resultado: response.data.resultado,
                data_realizacao: response.data.data_realizacao,
                data_cancelamento: response.data.data_cancelamento,
                necessita_motorista: response.data.necessita_motorista,
                arquivo_comprovante: response.data.arquivo_comprovante,
                arquivo_nota_fiscal: response.data.arquivo_nota_fiscal,
                arquivo_motorista_comprovante: response.data.arquivo_motorista_comprovante,
                arquivo_motorista_nota_fiscal: response.data.arquivo_motorista_nota_fiscal,
                arquivo_comprovante_upload: null,
                arquivo_nota_fiscal_upload: null,
                arquivo_motorista_comprovante_upload: null,
                arquivo_motorista_nota_fiscal_upload: null,
                motorista_orcamento: response.data.motorista_orcamento,
                motorista_orcamento_volta: response.data.motorista_orcamento_volta,
                motorista_contato: response.data.motorista_contato,
                motorista_data_aprovacao: response.data.motorista_data_aprovacao,
                data_aprovacao: response.data.data_aprovacao,
                dados_atendimento: response.data.dados_atendimento,
                status: response.data.status,
                status_salvo: response.data.status,
                focusMotorista: false,
                focusLaboratorio: false,
                focusProvedor: false
            };

            if (!exame_selecionado.id) {
                MySwal.close();
                this.setState({
                    exame_selecionado: {
                        ...this.state.exame_selecionado,
                        exames_solicitados: [...this.state.exame_selecionado.exames_solicitados, exameInserido]
                    }
                }, () => {
                });
            } else {
                // Se o status mudou para "iniciado" e não tinha agendamento, criar agendamento
                if (exame_selecionado.status === 'iniciado' && exame_selecionado.status_salvo !== 'iniciado') {
                    // Verifica se não tem agendamento existente
                    if (!exame_selecionado.dados_agendamento || Object.keys(exame_selecionado.dados_agendamento).length === 0) {
                        await this.criarAgendamentoParaExame(exame_selecionado, this.state.exame_selecionado.exames_solicitados.findIndex(e => e.id === exame_selecionado.id));
                    }
                }
                
                // Fecha o loading e exibe mensagem de sucesso
                MySwal.fire({
                    icon: 'success',
                    title: 'Sucesso!',
                    text: 'Exame atualizado com sucesso!',
                    timer: 2000,
                    showConfirmButton: false
                });

                // Atualiza o status_salvo no state para refletir o novo status salvo
                const indexExame = this.state.exame_selecionado.exames_solicitados.findIndex(e => e.id === exame_selecionado.id);
                if (indexExame !== -1) {
                    this.setState(prevState => ({
                        exame_selecionado: {
                            ...prevState.exame_selecionado,
                            exames_solicitados: prevState.exame_selecionado.exames_solicitados.map((ex, i) =>
                                i === indexExame ? { ...ex, status_salvo: exame_selecionado.status } : ex
                            )
                        }
                    }));
                }
            }
            this.getExames();
            if(this.props.onExameAtualizado) {
                this.props.onExameAtualizado();
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar exame, verifique os campos e tente novamente';

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            }
            else if (error.response && error.response.status === 400) {
                const data = error.response.data;
                let messages = [];
                for (let key in data) {
                    if (Array.isArray(data[key])) {
                        messages.push(...data[key]);
                    } else if (typeof data[key] === 'string') {
                        messages.push(data[key]);
                    } else if (typeof data[key] === 'object') {
                        // Trata erros aninhados se houver
                        for (let subKey in data[key]) {
                            if (Array.isArray(data[key][subKey])) {
                                messages.push(...data[key][subKey]);
                            } else {
                                messages.push(String(data[key][subKey]));
                            }
                        }
                    }
                }
                if (messages.length > 0) {
                    erro_msg = messages.join('\n');
                }
            }

            // Fecha o loading e exibe mensagem de erro
            MySwal.fire({
                icon: 'error',
                title: 'Erro!',
                text: erro_msg,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
            });

            this.setState({
                loading: false,
            })
        });
    }

    handleChangeExame = (e, fieldName, index) => {
        if (fieldName === 'medico_id') {
            this.setState({
                exame_selecionado: {
                    ...this.state.exame_selecionado,
                    medico_id: e.value,
                    medico_nome: e.label,
                    medico_crm: e.crm
                }
            });
        } else if(fieldName === 'data_recebimento') {
            let { value } = e.target;
            const agora = getDataAtualLocalISO();

            if (value > agora) {
                mensagemAlerta('A data de recebimento não pode ser no futuro!');
                value = agora;
            }

            this.setState({
                exame_selecionado: {
                    ...this.state.exame_selecionado,
                    data_recebimento: value
                }
            });
        } else if (fieldName === 'exames') {
            const examesSelecionados = e || [];
            const examesAtuais = this.state.exame_selecionado.exames_solicitados || [];
        
            // Crie um array com os IDs dos exames já cadastrados
            const atuaisIds = examesAtuais.map(item => String(item.servico_procedimento_id));
            const novosIds = examesSelecionados.map(item => String(item.value));
        
            if (novosIds.length > atuaisIds.length) {
                // Houve adição
                const novoExame = examesSelecionados.find(item => !atuaisIds.includes(String(item.value)));
        
                if (novoExame) {
                    const exameAdicionado = {
                        id: null,
                        servico_procedimento_id: novoExame.value,
                        servico_procedimento_nome: novoExame.label,
                    };
        
                    this.upsertExameSolicitado(exameAdicionado, examesSelecionados);
                }
            } else if (novosIds.length < atuaisIds.length) {
                // Houve remoção
                const removido = atuaisIds.find(id => !novosIds.includes(id));
                const exameIdRemovido = examesAtuais.find(item => String(item.servico_procedimento_id) === String(removido));
                // Aqui você pode, por exemplo, filtrar o exame removido e atualizar o estado
                const examesFiltrados = examesAtuais.filter(item =>
                    String(item.servico_procedimento_id) !== String(removido)
                );

                this.excluirExameSolicitado(exameIdRemovido, examesFiltrados);
            }

        } else {
            const { name, value } = e.target;
            this.setState({
                exame_selecionado: {
                    ...this.state.exame_selecionado,
                    [name]: value
                }
            });
        }
    };


    handleChangeExameSolicitado = (e, fieldName, index) => {
        if (fieldName == 'motorista_id') {
            if(e.value == 'outro') {
                this.setState(prevState => ({
                    exame_selecionado: {
                        ...prevState.exame_selecionado, exames_solicitados: this.state.exame_selecionado.exames_solicitados.map((exame, i) =>
                            i === index ? { ...exame, [fieldName]: e.value, motorista_nome: e.label, motorista_contato: '' } : exame
                        )
                    }
                }));
            } else {
                this.setState(prevState => ({
                    exame_selecionado: {
                        ...prevState.exame_selecionado, exames_solicitados: this.state.exame_selecionado.exames_solicitados.map((exame, i) =>
                            i === index ? { ...exame, [fieldName]: e.value, motorista_nome: e.label, motorista_contato: e.celular } : exame
                        )
                    }
                }));
            }
        } else if (fieldName == 'laboratorio_id') {

            this.setState(prevState => ({
                exame_selecionado: {
                    ...prevState.exame_selecionado, exames_solicitados: this.state.exame_selecionado.exames_solicitados.map((exame, i) =>
                        i === index ? { ...exame, [fieldName]: e.value, laboratorio_nome: e.label, laboratorio_endereco: e.laboratorio_endereco, laboratorio_bairro: e.laboratorio_bairro, laboratorio_numero: e.laboratorio_numero, laboratorio_complemento: e.laboratorio_complemento, laboratorio_cidade: e.laboratorio_cidade, laboratorio_estado: e.laboratorio_estado, laboratorio_cep: e.laboratorio_cep, laboratorio_telefone: e.laboratorio_telefone, laboratorio_telefone_2: e.laboratorio_telefone_2, laboratorio_telefone_3: e.laboratorio_telefone_3, laboratorio_email: e.laboratorio_email } : exame
                    )
                }
            }), () => {
                //console.log(this.state.exame_selecionado);
            });
        } else if (fieldName == 'servico_transporte_id') {
            this.setState(prevState => ({
                exame_selecionado: {
                    ...prevState.exame_selecionado, exames_solicitados: this.state.exame_selecionado.exames_solicitados.map((exame, i) =>
                        i === index ? { ...exame, servico_transporte_id: e ? e.value : null, servico_transporte_nome: e ? e.label : null } : exame
                    )
                }
            }));
        } else if (fieldName == 'necessita_motorista') {
            this.setState(prevState => {
                return {
                    exame_selecionado: {
                        ...prevState.exame_selecionado, exames_solicitados: this.state.exame_selecionado.exames_solicitados.map((exame, i) =>
                            i === index ? { ...exame, ['necessita_motorista']: e.target.checked, motorista_id: null, motorista_nome: null } : exame
                        )
                    }
                };
            });
        } else if (fieldName == 'liberar_elegibilidade') {
            this.setState(prevState => ({
                exame_selecionado: {
                    ...prevState.exame_selecionado, exames_solicitados: this.state.exame_selecionado.exames_solicitados.map((exame, i) =>
                        i === index ? { ...exame, liberar_elegibilidade: e.target.checked } : exame
                    )
                }
            }));
        } else if (fieldName == 'data_aprovacao') {
            let { name, value } = e.target;

            const agora = getDataAtualLocalISO();

            if (value > agora) {
                mensagemAlerta('A data de aprovação não pode ser no futuro!');
                value = agora;
            }

            this.setState({
                exame_selecionado: {
                    ...this.state.exame_selecionado,
                    exames_solicitados: this.state.exame_selecionado.exames_solicitados.map((exame, i) =>
                        i === index ? { ...exame, [name]: value } : exame
                    )
                }
            });

        } else if (fieldName == 'motorista_orcamento' || fieldName == 'motorista_orcamento_volta' || fieldName == 'orcamento') {
            const { name, value } = e.target;
            this.setState({
                exame_selecionado: {
                    ...this.state.exame_selecionado, exames_solicitados: this.state.exame_selecionado.exames_solicitados.map((exame, i) =>
                        i === index ? { ...exame, [name]: formatarValor(value) } : exame
                    )
                }
            });
        } else {
            const { name, value } = e.target;
            this.setState({
                exame_selecionado: {
                    ...this.state.exame_selecionado, exames_solicitados: this.state.exame_selecionado.exames_solicitados.map((exame, i) =>
                        i === index ? { ...exame, [name]: value } : exame
                    )
                }
            }, () => {
            });
        }
    }

    carregarMedicos = async (busca) => {
        if (!this.state.focusMedico) {
            return [];
        }
        try {
            const response = await api.get(`/pessoas/prestadores/?programa_id=${this.state.programa_id}&categoria=medicos&nome=${busca}&is_active=1`);
            //const response = await api.get(`/programas/aplicacoes-status/`);
            const opcoesFiltradas = response.data.results.map(medico => ({
                value: medico.id,
                label: medico.nome,
                crm: medico.registro + ' - ' + medico.registro_uf,
            }));

            return opcoesFiltradas;
        } catch (error) {
            console.error('Erro ao carregar médicos:', error);
            Sentry.captureException('Erro ao carregar médicos:', error);
        }
    };

    carregarMotoristas = async (busca, index) => {
        if (!this.state.exame_selecionado.exames_solicitados[index].focusMotorista) {
            return [];
        }
        try {
            const response = await api.get(`/pessoas/prestadores/?categoria=motoristas|logistica&nome=${busca}&is_active=1`);
            //const response = await api.get(`/programas/aplicacoes-status/`);
            const opcoesFiltradas = response.data.results.map(motorista => ({
                value: motorista.id,
                label: motorista.nome,
                celular: motorista.celular
            }));

            return opcoesFiltradas;
        } catch (error) {
            console.error('Erro ao carregar transportes:', error);
            Sentry.captureException('Erro ao carregar transportes:', error);
        }
    };

    carregarLaboratorios = async (busca, index) => {
        if (!this.state.exame_selecionado.exames_solicitados[index].focusLaboratorio) {
            return [];
        }
        try {
            const filtroBeneficiario = this.state.exame_selecionado.exames_solicitados[index].dados_atendimento.beneficiario_id ? this.state.exame_selecionado.exames_solicitados[index].dados_atendimento.beneficiario_id : null;

            let url = `/pessoas/prestadores/?programa_id=${this.state.programa_id}&nome=${busca}&busca_distancia=sim&servico_id=${this.state.exame_selecionado.exames_solicitados[index].servico_procedimento_id}&beneficiario_id=${filtroBeneficiario}&is_active=1`;

            if (getConfig(this.state.programa_dados?.configuracoes, 'agendamento.filtrar_prestadores_estado', false)) {
                url += `&uf=${this.state.paciente_dados?.uf}`;
            }

            const response = await api.get(url);

            const resultadosAtivos = response.data.results
                .filter(lab => lab.is_active);

            const opcoesFiltradas = resultadosAtivos.map(laboratorio => ({
                value: laboratorio.id,
                label: laboratorio.distancia ? laboratorio.nome + ' (' + laboratorio.endereco + ' - ' + laboratorio.bairro + ', Nº ' + laboratorio.numero + ' - ' + laboratorio.distancia + 'km)' : laboratorio.nome + ' (' + laboratorio.nome_fantasia + ' - ' + laboratorio.cidade + '/' + laboratorio.uf + '. ' + laboratorio.endereco + ' - ' + laboratorio.bairro + ', Nº ' + laboratorio.numero + ')',
                laboratorio_endereco: laboratorio.endereco || "",
                laboratorio_bairro: laboratorio.bairro || "",
                laboratorio_numero: laboratorio.numero || "",
                laboratorio_complemento: laboratorio.complemento || "",
                laboratorio_cidade: laboratorio.cidade || "",
                laboratorio_estado: laboratorio.uf || "",
                laboratorio_cep: laboratorio.cep || "",
                laboratorio_telefone: laboratorio.telefone || "",
                laboratorio_telefone_2: laboratorio.telefone_2 || "",
                laboratorio_telefone_3: laboratorio.telefone_3 || "",
                laboratorio_email: laboratorio.email || "",
            }));

            return opcoesFiltradas;
        } catch (error) {
            console.error('Erro ao carregar laboratórios:', error);
            Sentry.captureException('Erro ao carregar laboratórios:', error);
        }
    };

    carregarExames = async (inputValue) => {
        try {
            let opcoes = [];

            // Se configuração exibir_todos_exames for true, busca do endpoint geral
            if (getConfig(this.state.programa_dados?.configuracoes, 'exames.exibir_todos_exames', false)) {
                const response = await api.get(
                    `/servicos_procedimentos/?nome=${inputValue}&servico_video_conferencia=0`
                );
                
                opcoes = response.data.results.map(item => ({
                    value: item.id,
                    label: `${item.nome} (#${item.id})`,
                    valor: null
                }));
            } else {
                // Busca somente os serviços do programa
                let url = `/programas/servicos_procedimentos/?servico_procedimento=${inputValue}&status=1&programa=${this.state.programa_id}`;

                if (this.props.doenca_id) {
                    url += `&doenca_id=${this.props.doenca_id}`;
                }

                // Realiza a primeira requisição para obter serviços do programa
                const responsePrograma = await api.get(url);
                const opcoesDoPrograma = responsePrograma.data.results;

                // monta o array de opções direto a partir do que já veio do programa
                opcoes = opcoesDoPrograma.filter(item => !item.dados_servico?.ocultar_solicitacao_exames).map(item => ({
                    value: item.servico_procedimento_id,
                    label: `${item.dados_servico.nome} (#${item.servico_procedimento_id})`,
                    valor: formatarValor(item.valor)
                }));
            }
            
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar serviços/procedimentos:', error);
            return [];
        }
    };

    onChangeArquivo = (e, index = null, tipo = null) => {
        if (e.target.files && e.target.files[0]) {
            const arquivo_enviado = e.target.files[0];

            // Armazena o arquivo para upload
            if (index !== null) {
                this.setState({ exame_selecionado: { ...this.state.exame_selecionado, exames_solicitados: this.state.exame_selecionado.exames_solicitados.map((exame, i) =>
                    i === index ? { ...exame, [e.target.name]: arquivo_enviado } : exame
                ) } });
            }
        }
    };

    onChangeArquivoMotorista = (e, index = null, tipo = null) => {
        if (e.target.files && e.target.files[0]) {
            const arquivo_enviado = e.target.files[0];
            this.setState({ exame_selecionado: { ...this.state.exame_selecionado, exames_solicitados: this.state.exame_selecionado.exames_solicitados.map((exame, i) =>
                i === index ? { ...exame, [e.target.name]: arquivo_enviado } : exame
            ) } });
        }
    };

    onChangeCep(e, index) {
        const cep = e.target.value;
        this.setState({ exame_selecionado: { ...this.state.exame_selecionado, exames_solicitados: this.state.exame_selecionado.exames_solicitados.map((exame, i) =>
            i === index ? { ...exame, provedor_cep: cep } : exame
        ) } });

        if (cep.length === 9) { // Verifica se o CEP tem 9 caracteres
            axios.get(`https://viacep.com.br/ws/${cep}/json/`)
                .then(res => {
                    if (!res.data.erro) {
                        this.setState({
                            exame_selecionado: { ...this.state.exame_selecionado, exames_solicitados: this.state.exame_selecionado.exames_solicitados.map((exame, i) =>
                                i === index ? { ...exame, provedor_endereco: res.data.logradouro, provedor_bairro: res.data.bairro, provedor_cidade: res.data.localidade, provedor_estado: res.data.uf } : exame
                            ) }
                        });
                    } else {
                        // Tratar o caso de CEP não encontrado
                        mensagemAlerta("CEP não encontrado.", 'warning');
                    }
                })
                .catch(error => {
                    // Tratar erro na requisição
                    mensagemAlerta("Erro na requisição:", 'warning');
                    //Sentry.captureException("Erro na requisição:", error);
                });
        }
    }

    enviaExame = (e) => {
        e.preventDefault();

        const configuracoes = this.props.programa_dados?.configuracoes || {};
        const configExames = configuracoes['Exames_Component'] || {};
        const motivoHabilitado = configExames['Motivo_do_Exame']?.includes('habilitado');

        if (!this.state.exame_selecionado.medico_id) {
            mensagemAlerta('Nenhum médico selecionado. Por favor, selecione um médico para continuar.', 'warning');
            return; // Interrompe a execução do método
        }

        if (!this.state.exame_selecionado.status) {
            mensagemAlerta('Nenhum status selecionado. Por favor, selecione um status para continuar.', 'warning');
            return; // Interrompe a execução do método
        }

        if (!this.state.exame_selecionado.data_recebimento) {
            mensagemAlerta('Nenhum data de recebimento selecionado. Por favor, selecione um data de recebimento para continuar.', 'warning');
            return; // Interrompe a execução do método
        }

        if (motivoHabilitado) {
            if (!this.state.exame_selecionado.motivo) {
                mensagemAlerta('Nenhum motivo selecionado. Por favor, selecione um motivo para continuar.', 'warning');
                return; 
            }

            if (this.state.exame_selecionado.motivo == 'outro' && this.state.exame_selecionado.motivo_outros.length <= 30) {
                mensagemAlerta('O motivo deve conter no mínimo 30 caracteres.', 'warning');
                return; 
            }
        }

        const MySwal = withReactContent(Swal)

        this.setState({
            loading: true,
        });

        //vererifica se é edição ou adição
        const url = (this.state.exame_selecionado.id) ? '/exames/' + this.state.exame_selecionado.id + '/' : '/exames/'
        const metodo = (this.state.exame_selecionado.id) ? 'put' : 'post'
        const formData = new FormData();
        formData.append('atendimento_id', this.state.atendimento_id ?? '');
        formData.append('medico_id', this.state.exame_selecionado.medico_id ?? '');
        formData.append('status', this.state.exame_selecionado.status ?? '');
        formData.append('motivo_status', this.state.exame_selecionado.motivo_status ?? '');
        if(this.state.exame_selecionado.status === 'recusado' || this.state.exame_selecionado.status === 'cancelado' || this.state.exame_selecionado.status === 'stand_by') {
            formData.append('data_recusa', new Date().toISOString().slice(0, 16));
            formData.append('motivo_recusa', this.state.exame_selecionado.motivo_recusa ?? '');
        }
        formData.append('data_recebimento', this.state.exame_selecionado.data_recebimento ?? '');

        if(this.state.exame_selecionado.motivo) {
            formData.append('motivo', this.state.exame_selecionado.motivo ?? '');
        } else {
            formData.append('motivo', 'diagnostico');
        }

        formData.append('motivo_outros', this.state.exame_selecionado.motivo_outros ?? '');

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData
        })
            .then(response => {

                const textSwal = (this.state.exame_selecionado.id) ? 'Pedido de exame atualizado com sucesso' : 'Pedido de exame cadastrado com sucesso';

                this.setState({
                    loading: false,
                    showModalExame: false
                });

                // Tudo concluído aqui, agora pode navegar
                MySwal.fire({
                    title: <p>{textSwal}</p>,
                    icon: 'success',
                    showCloseButton: true,
                }).then((result) => {
                    //redireciona
                    this.getExames();
                    this.handleCloseModalExame();
                    this.handleShowModalExame(response.data);
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao cadastrar exame, verifique os campos e tente novamente';

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                }
                else if (error.response && error.response.status === 400) {
                    const data = error.response.data;
                    let messages = [];
                    for (let key in data) {
                        if (Array.isArray(data[key])) {
                            messages.push(...data[key]);
                        } else if (typeof data[key] === 'string') {
                            messages.push(data[key]);
                        } else if (typeof data[key] === 'object') {
                            for (let subKey in data[key]) {
                                if (Array.isArray(data[key][subKey])) {
                                    messages.push(...data[key][subKey]);
                                } else {
                                    messages.push(String(data[key][subKey]));
                                }
                            }
                        }
                    }
                    if (messages.length > 0) {
                        erro_msg = messages.join('\n');
                    }
                }

                mensagemAlerta(erro_msg, 'error');

                this.setState({
                    loading: false,
                })
            });
    };

    deletarExame = (item_id) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Excluir exame?',
            text: "Tem certeza que deseja excluir este exame?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loading: true });

                api.delete(`/exames/${item_id}/`)
                    .then(response => {
                        MySwal.fire(
                            'Excluído!',
                            'O exame foi excluído com sucesso.',
                            'success'
                        );
                        this.setState({ loading: false });
                        //consulta os exames do atendimento
                        this.getExames();
                    })
                    .catch(error => {
                        Sentry.captureException('Houve um erro ao tentar excluir o exame. Por favor, tente novamente.', error);

                        MySwal.fire(
                            'Erro!',
                            'Houve um erro ao tentar excluir o exame. Por favor, tente novamente.',
                            'error'
                        );
                        this.setState({ loading: false });
                    });
            }
        });
    }
    
    novoPedidoExameMedico = () => {
        this.handleAbrirPreSolicitacao();
    }

    limparExame = () => {
        this.setState({
            exame_selecionado:
            {
                ...this.state.exame_selecionado,
                id: null,
                exames_solicitados: [],
                medico_id: null,
                medico_nome: null,
                medico_crm: null,
                status: null,
                motivo_status: null,
                data_recusa: null,
                motivo_recusa: null,
                data_recebimento: null,
                motivo: null,
                motivo_outros: '',
                exames: [],
                focusMedico: false,
                focusExame: false,
                arquivos_pedidos: []
            }
        });
    }

    handleShowModalExame = (exame) => {
        if (exame) {
            this.setState({ showModalExame: true, exame_selecionado: exame }, () => {
                this.setState({
                    exame_selecionado: {
                        ...this.state.exame_selecionado,
                        medico_nome: exame.dados_medico.nome,
                        medico_crm: exame.dados_medico.registro + ' - ' + exame.dados_medico.registro_uf,
                        arquivos: exame.arquivos,
                        status: exame.status,
                        status_salvo: exame.status,
                        motivo_status: exame.motivo_status,
                        data_recusa: exame.data_recusa,
                        motivo_recusa: exame.motivo_recusa,
                        data_recebimento: exame.data_recebimento,
                        focusExame: false,
                        focusMedico: false,
                        arquivos_pedidos: exame.dados_arquivos_pedidos,
                        exames_solicitados: exame.exames_solicitados.map(exame => ({
                            ...exame,
                            status: exame.status,
                            status_salvo: exame.status,
                            data_agendamento: exame.data_agendamento,
                            data_agendada: exame.data_agendada,
                            data_realizacao: exame.data_realizacao,
                            data_cancelamento: exame.data_cancelamento,
                            data_aprovacao: exame.data_aprovacao,
                            servico_procedimento_nome: exame.dados_servico_procedimento.nome,
                            servico_procedimento_id: exame.servico_procedimento_id,
                            laboratorio_id: exame.laboratorio_id,
                            laboratorio_nome: exame.dados_laboratorio.nome,
                            laboratorio_endereco: exame.dados_laboratorio.endereco,
                            laboratorio_bairro: exame.dados_laboratorio.bairro,
                            laboratorio_numero: exame.dados_laboratorio.numero,
                            laboratorio_complemento: exame.dados_laboratorio.complemento,
                            laboratorio_cidade: exame.dados_laboratorio.cidade,
                            laboratorio_estado: exame.dados_laboratorio.uf,
                            laboratorio_cep: exame.dados_laboratorio.cep,
                            laboratorio_telefone: exame.dados_laboratorio.telefone,
                            laboratorio_telefone_2: exame.dados_laboratorio.telefone_2,
                            laboratorio_telefone_3: exame.dados_laboratorio.telefone_3,
                            laboratorio_email: exame.dados_laboratorio.email,
                            necessita_motorista: exame.motorista_id ? true : false,
                            motorista_nome: exame.dados_motorista.nome,
                            motorista_id: exame.motorista_id,
                            necessita_laboratorio: exame.laboratorio_id ? true : false,
                            provedor_id: exame.provedor_id,
                            provedor_nome_fantasia: exame.dados_provedor_nao_credenciado.nome_fantasia,
                            provedor_telefone: exame.dados_provedor_nao_credenciado.telefone,
                            provedor_banco: exame.dados_provedor_nao_credenciado.banco,
                            provedor_agencia: exame.dados_provedor_nao_credenciado.agencia,
                            provedor_conta: exame.dados_provedor_nao_credenciado.conta,
                            provedor_credenciado: exame.provedor_credenciado,
                            necessita_motorista: exame.necessita_motorista,
                            arquivo_comprovante: exame.arquivo_comprovante,
                            arquivo_nota_fiscal: exame.arquivo_nota_fiscal,
                            arquivo_motorista_comprovante: exame.arquivo_motorista_comprovante,
                            arquivo_motorista_nota_fiscal: exame.arquivo_motorista_nota_fiscal,
                            focusMotorista: false,
                            focusLaboratorio: false,
                            focusFormaPagamento: false,
                            focusProvedor: false,
                            questionario: exame.questionario,
                        }))
                    }
                }, () => {
                    this.carregaStatusExames(exame.programa_id || this.state.programa_id);
                });
            });
        } else {
            this.setState({
                showModalExame: true,
                exame_selecionado: {
                    ...this.state.exame_selecionado,
                    data_recebimento: getDataAtualLocalISO(),
                    arquivos_pedidos: [],
                    status_salvo: ''
                }
            });
        }
    }

    handleCloseModalExame = () => {
        this.setState({ showModalExame: false, focusMedico: false, focusExame: false });
        this.limparExame();
        // tira o foco de qualquer input que possa estar ativo
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
    }

    handleDownloadArquivo = (arquivo, index = null) => {
        const url = index !== null ? this.state.exame_selecionado.exames_solicitados[index][arquivo] : this.state.exame_selecionado[arquivo];
        window.open(url, '_blank');
    }

    // Métodos para gerenciar arquivos de pedidos de exames
    adicionarArquivoPedido = () => {
        const novoArquivo = {
            id: null,
            exame_id: this.state.exame_selecionado.id,
            arquivo: null,
            arquivo_upload: null,
            nome_original: '',
            data_upload: null
        };

        this.setState({
            exame_selecionado: {
                ...this.state.exame_selecionado,
                arquivos_pedidos: [...this.state.exame_selecionado.arquivos_pedidos, novoArquivo]
            }
        });
    }

    excluirArquivoPedido = (arquivoIndex) => {
        const MySwal = withReactContent(Swal);
        const arquivo = this.state.exame_selecionado.arquivos_pedidos[arquivoIndex];
        
        if (arquivo.id) {
            // Arquivo já salvo no servidor, precisa fazer requisição para excluir
            const url = `/exames/pedidos/arquivos/${arquivo.id}/`;
            
            MySwal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Tem certeza que deseja excluir este arquivo?',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Sim',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                cancelButtonText: 'Não'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    api({
                        method: 'delete',
                        url: url
                    })
                    .then(response => {
                        mensagemAlerta('Arquivo excluído com sucesso!', 'success');
                        const arquivosAtualizados = this.state.exame_selecionado.arquivos_pedidos.filter((_, index) => index !== arquivoIndex);
                        this.setState({
                            exame_selecionado: {
                                ...this.state.exame_selecionado,
                                arquivos_pedidos: arquivosAtualizados
                            }
                        });
                    })
                    .catch(error => {
                        mensagemAlerta('Erro ao excluir arquivo!', 'error');
                        console.error('Erro ao excluir arquivo:', error);
                    });
                }
            });
        } else {
            // Arquivo ainda não salvo, apenas remove da lista
            const arquivosAtualizados = this.state.exame_selecionado.arquivos_pedidos.filter((_, index) => index !== arquivoIndex);
            this.setState({
                exame_selecionado: {
                    ...this.state.exame_selecionado,
                    arquivos_pedidos: arquivosAtualizados
                }
            });
        }
    }

    uploadArquivoPedido = (arquivoIndex) => {
        const arquivo = this.state.exame_selecionado.arquivos_pedidos[arquivoIndex];
        
        if (!arquivo.arquivo_upload) {
            mensagemAlerta('Selecione um arquivo para fazer upload!', 'warning');
            return;
        }

        if (!this.state.exame_selecionado.id) {
            mensagemAlerta('É necessário salvar o exame antes de fazer upload dos arquivos!', 'warning');
            return;
        }

        const url = arquivo.id ? `/exames/pedidos/arquivos/${arquivo.id}/` : '/exames/pedidos/arquivos/';
        const metodo = arquivo.id ? 'put' : 'post';
        const formData = new FormData();
        
        formData.append('exame_id', this.state.exame_selecionado.id);
        formData.append('arquivo', arquivo.arquivo_upload);

        api({
            method: metodo,
            url: url,
            data: formData
        })
        .then(response => {
            mensagemAlerta('Arquivo enviado com sucesso!', 'success');
            
            // Atualiza o arquivo na lista com os dados retornados
            const arquivosAtualizados = this.state.exame_selecionado.arquivos_pedidos.map((arq, index) => {
                if (index === arquivoIndex) {
                    return {
                        id: response.data.id,
                        exame_id: response.data.exame_id,
                        arquivo: response.data.arquivo,
                        arquivo_upload: null,
                        nome_original: response.data.nome_original,
                        data_upload: response.data.data_upload
                    };
                }
                return arq;
            });

            this.setState({
                exame_selecionado: {
                    ...this.state.exame_selecionado,
                    arquivos_pedidos: arquivosAtualizados
                }
            }, () => {
                this.getExames();
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao enviar arquivo, tente novamente';

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            }

            mensagemAlerta(erro_msg, 'error');
            console.error('Erro ao enviar arquivo:', error);
        });
    }

    onChangeArquivoPedido = (e, arquivoIndex) => {
        if (e.target.files && e.target.files[0]) {
            const arquivo_enviado = e.target.files[0];
            
            const arquivosAtualizados = this.state.exame_selecionado.arquivos_pedidos.map((arquivo, index) => {
                if (index === arquivoIndex) {
                    return {
                        ...arquivo,
                        arquivo_upload: arquivo_enviado,
                        nome_original: arquivo_enviado.name
                    };
                }
                return arquivo;
            });

            this.setState({
                exame_selecionado: {
                    ...this.state.exame_selecionado,
                    arquivos_pedidos: arquivosAtualizados
                }
            });
        }
    }

    handleDownloadArquivoPedido = (arquivoIndex) => {
        const arquivo = this.state.exame_selecionado.arquivos_pedidos[arquivoIndex];
        if (arquivo.arquivo) {
            window.open(arquivo.arquivo, '_blank');
        }
    }

    carregaStatusMotivos = async (programaId) => {
        const statusMotivos = programaId || this.state.programa_id || (this.state.exame_selecionado && this.state.exame_selecionado.programa_id);

        // monta defaults
        const defaultStatusOptions = statusExame && typeof statusExame === 'object'
            ? Object.keys(statusExame).map(key => ({
                value: key,
                label: statusExame[key]
            }))
            : [];

        const defaultMotivoOptions = this.motivos_exames || [];
        
        if (!statusMotivos) {
            this.setState({
                statusOptions: defaultStatusOptions,
                motivoOptions: defaultMotivoOptions
            });
            return;
        }

        try {
            const [resStatus, resMotivo] = await Promise.all([
                api.get(`/exames/status_motivos/?programa_id=${encodeURIComponent(statusMotivos)}&area=pedido-exame&tipo=status`),
                api.get(`/exames/status_motivos/?programa_id=${encodeURIComponent(statusMotivos)}&area=pedido-exame&tipo=motivo`)
            ]);

            const mapList = (resp) => {
                const list = resp && resp.data ? (resp.data.results ? resp.data.results : resp.data) : [];
                return Array.isArray(list) ? list.map(item => ({
                    value: item.slug ?? String(item.id ?? item), 
                    label: item.nome ?? item.programa__nome ?? String(item.slug ?? item.id ?? item)
                })) : [];
            };

            const statusOptions = mapList(resStatus);
            const motivoOptions = mapList(resMotivo);

            this.setState({
                statusOptions: statusOptions.length ? statusOptions : defaultStatusOptions,
                motivoOptions: motivoOptions.length ? motivoOptions : defaultMotivoOptions
            });
        } catch (err) {
            console.error('Erro carregando status/motivo:', err);
            // fallback para os padrões
            this.setState({
                statusOptions: defaultStatusOptions,
                motivoOptions: defaultMotivoOptions
            });
        }
    };

    carregaStatusExames = async (programaId) => {
        const statusExames = programaId || this.state.programa_id || (this.state.exame_selecionado && this.state.exame_selecionado.programa_id);

        // monta defaults a partir de statusExamesSelecionados
        let defaultStatusOptionsExame = [];
        if (Array.isArray(statusExamesSelecionados)) {
            // se o utils já trouxer array de opções, usa direto
            defaultStatusOptionsExame = statusExamesSelecionados;
        } else if (statusExamesSelecionados && typeof statusExamesSelecionados === 'object') {
            defaultStatusOptionsExame = Object.keys(statusExamesSelecionados).map(key => ({
                value: key,
                label: statusExamesSelecionados[key]
            }));
        }
        
        if (!statusExames) {
            this.setState({ statusOptionsExame: [] });
            return;
        }

        try {
            const res = await api.get(`/exames/status_motivos/?programa_id=${encodeURIComponent(statusExames)}&area=exame&tipo=status`);
            const list = res && res.data ? (res.data.results ? res.data.results : res.data) : [];
            const options = Array.isArray(list) ? list.map(item => ({
            value: item.slug ?? String(item.id ?? item),
            label: item.nome ?? item.programa__nome ?? String(item.slug ?? item.id ?? item)
            })) : [];
            
            this.setState({
                statusOptionsExame: options.length ? options : defaultStatusOptionsExame
            });
        } catch (err) {
            console.error('Erro carregando status (exame):', err);
            this.setState({ statusOptionsExame: defaultStatusOptionsExame });
        }
    };

    getStatusLabel = (slug) => {
        // Primeiro tenta buscar nos status dinâmicos
        const status = this.state.statusOptions.find(s => s.value === slug);
        if (status) return status.label;
        
        // Fallback para o objeto fixo importado
        return statusExame[slug] || slug || '-';
    };

    getMotivoLabel = (slug) => {
        // Primeiro tenta buscar nos motivos dinâmicos
        const motivo = this.state.motivoOptions.find(m => m.value === slug);
        if (motivo) return motivo.label;
        
        // Fallback para o array fixo
        const motivoFixo = this.motivos_exames.find(m => m.value === slug);
        return motivoFixo ? motivoFixo.label : slug || '-';
    };

    handleAbrirPreSolicitacao = async () => {
        this.setState({ showModalPreSolicitacao: true, pre_arquivo_upload: null, pre_examesSelecionados: new Set() });
        
        try {
            let url = `/programas/servicos_procedimentos/?status=1&programa=${this.state.programa_id}`;
            
            if (this.props.doenca_id) {
                url += `&doenca_id=${this.props.doenca_id}`;
            }

            const resp = await api.get(url);
            
            let lista = resp.data.results.map(item => ({
                id: item.servico_procedimento_id,
                nome: item.dados_servico.nome,
                configuracoes: item.dados_servico.configuracoes,
                valor: formatarValor(item.valor),
                ocultar_solicitacao_exames: item.dados_servico.ocultar_solicitacao_exames
            }));
            
            const extraExamsList = this.props.exames_extras_solicitacao || [];
            if (extraExamsList.length > 0) {
                const examesSolicitadosIds = [];
                const statusIgnorados = ['realizado', 'cancelado', 'recusado'];

                if (Array.isArray(this.state.exames?.results)) {
                    this.state.exames.results.forEach(pedido => {
                        (pedido.exames_solicitados || []).forEach(exame => {
                            if (exame.servico_procedimento_id && !statusIgnorados.includes(exame.status)) {
                                examesSolicitadosIds.push(exame.servico_procedimento_id);
                            }
                        });
                    });
                }
                
                const extrasPendentes = extraExamsList.filter(e => !examesSolicitadosIds.includes(e));

                if (extrasPendentes.length > 0) {
                    const listaFiltrada = lista.filter(item => extrasPendentes.includes(item.id));
                    if (listaFiltrada.length > 0) {
                        lista = listaFiltrada;
                    }
                }
            }

            this.setState({ listaExamesDisponiveis: lista });
        } catch (e) {
            console.error(e);
            mensagemAlerta('Erro ao carregar exames disponíveis', 'error');
        }
    }

    handleFecharPreSolicitacao = () => {
        this.setState({ showModalPreSolicitacao: false, pre_arquivo_upload: null, pre_examesSelecionados: new Set() });
    }

    toggleExamePre = (id) => {
        const permiteMultiplos = this.props.habilitar_selecionar_multiplos_exames || false;

        this.setState(prev => {
            let novoSet;

            if (permiteMultiplos) {
                // Lógica CHECKBOX (Multiplos)
                novoSet = new Set(prev.pre_examesSelecionados);
                if (novoSet.has(id)) {
                    novoSet.delete(id);
                } else {
                    novoSet.add(id);
                }
            } else {
                // Lógica RADIO (Único)
                novoSet = new Set();
                novoSet.add(id);
            }

            const novasRespostas = permiteMultiplos ? prev.respostasPorServico : { [id]: {} };
            const novosErros = permiteMultiplos ? prev.validacaoErros : {};
            const novosArquivos = permiteMultiplos ? prev.arquivosDinamicos : {};

            return { 
                pre_examesSelecionados: novoSet,
                respostasPorServico: novasRespostas,
                validacaoErros: novosErros,
                arquivosDinamicos: novosArquivos
            };
        });
    }

    onChangeArquivoPre = (e) => {
        const f = e.target.files?.[0] || null;
        this.setState({ pre_arquivo_upload: f });
    }

    onChangeResposta = (servicoId, questionId, value) => {
        this.setState(prev => {
            const atual = { ...(prev.respostasPorServico[servicoId] || {}) };
            atual[questionId] = value;

            // Poda respostas de perguntas que deixaram de ser visíveis após esta mudança
            // (ex.: trocar uma resposta muda o ramo do questionário). Sem isso, uma resposta
            // "órfã" de uma pergunta oculta continuaria contando no bloqueio e o exame ficaria
            // travado mesmo após mudar para uma resposta elegível. Itera até estabilizar (cascata).
            const item = this.state.listaExamesDisponiveis.find(x => x.id === servicoId);
            const config = item?.configuracoes || {};
            const todas = (config?.questionario?.questions || []);
            let mudou = true;
            while (mudou) {
                mudou = false;
                const visiveisIds = new Set(this.getVisibleQuestions(config, atual).map(q => q.id));
                for (const q of todas) {
                    if (q.type === 'info' || q.type === 'block') continue;
                    if (!visiveisIds.has(q.id) && atual[q.id] !== undefined) {
                        delete atual[q.id];
                        mudou = true;
                    }
                }
            }

            const validacaoErros = { ...(prev.validacaoErros || {}) };
            delete validacaoErros[questionId];

            return {
                respostasPorServico: { ...prev.respostasPorServico, [servicoId]: atual },
                validacaoErros
            };
        });
    };

    onChangeArquivoDinamico = (servicoId, questionId, e) => {
        if (e.target.files && e.target.files[0]) {
            const arquivo = e.target.files[0];
            const key = `${servicoId}_${questionId}`;
            
            this.setState(prev => ({
                arquivosDinamicos: {
                    ...prev.arquivosDinamicos,
                    [key]: arquivo
                },
                respostasPorServico: {
                    ...prev.respostasPorServico,
                    [servicoId]: {
                        ...(prev.respostasPorServico[servicoId] || {}),
                        [questionId]: arquivo.name 
                    }
                }
            }));

            const validacaoErros = { ...this.state.validacaoErros };
            delete validacaoErros[questionId];
            this.setState({ validacaoErros });
        }
    }

    normalizeResposta = (v) => {
        if (v === undefined || v === null) return "";

        v = String(v).trim().toLowerCase();

        // normalizações adicionais
        if (v === "nao") return "não";
        if (v === "sim") return "sim";
        if (["yes", "y", "true", "1"].includes(v)) return "sim";
        if (["no", "n", "false", "0"].includes(v)) return "não";

        return v;
    };

    // Avalia uma regra de contagem/limiar de respostas "sim" em um grupo de perguntas.
    // A regra só dispara quando TODAS as perguntas do grupo estiverem respondidas
    // (evita exibir a negativa de elegibilidade antes de o médico terminar o questionário).
    avaliarRegraContagem = (rule, allAnswers) => {
        const group = Array.isArray(rule?.group) ? rule.group : [];
        if (group.length === 0) return false;

        const todasRespondidas = group.every(qid => {
            const v = (allAnswers || {})[qid];
            return v !== undefined && v !== null && String(v).trim() !== '';
        });
        if (!todasRespondidas) return false;

        const simCount = group.reduce(
            (acc, qid) => acc + (this.normalizeResposta((allAnswers || {})[qid]) === 'sim' ? 1 : 0),
            0
        );

        let cond = true;
        if (rule.sim_max !== undefined && rule.sim_max !== null) cond = cond && (simCount <= Number(rule.sim_max));
        if (rule.sim_min !== undefined && rule.sim_min !== null) cond = cond && (simCount >= Number(rule.sim_min));
        return cond;
    };

    // Avalia o bloco show_if_count (regras agregadas de elegibilidade) de uma pergunta.
    // Estrutura: { operator: 'OR'|'AND', rules: [ { group: [ids], sim_max?: N, sim_min?: N } ] }
    avaliarShowIfCount = (question, allAnswers) => {
        const cfg = question?.show_if_count;
        if (!cfg) return true;
        const rules = Array.isArray(cfg.rules) ? cfg.rules : [];
        if (rules.length === 0) return true;
        const op = String(cfg.operator || 'OR').toUpperCase();
        const resultados = rules.map(r => this.avaliarRegraContagem(r, allAnswers));
        return op === 'AND' ? resultados.every(Boolean) : resultados.some(Boolean);
    };

    // Avalia uma condição isolada. Suporta:
    //  - igualdade de resposta: { question_id, equals }
    //  - limiar numérico:       { question_id, gt|gte|lt|lte: N } (combináveis para faixa)
    //  - doença do paciente:    { doenca_id: N } (vem do atendimento via props, não do questionário)
    avaliarCondicao = (cond, allAnswers) => {
        if (!cond || typeof cond !== 'object') return false;

        // Condição por doença de base do atendimento
        if (cond.doenca_id !== undefined && cond.doenca_id !== null) {
            return Number(this.props.doenca_id) === Number(cond.doenca_id);
        }

        const valor = (allAnswers || {})[cond.question_id];

        // Condição numérica (limiares)
        const temNumerico = ['gt', 'gte', 'lt', 'lte'].some(op => cond[op] !== undefined && cond[op] !== null);
        if (temNumerico) {
            const num = parseFloat(String(valor).replace(',', '.'));
            if (isNaN(num)) return false;
            if (cond.gt !== undefined && cond.gt !== null && !(num > Number(cond.gt))) return false;
            if (cond.gte !== undefined && cond.gte !== null && !(num >= Number(cond.gte))) return false;
            if (cond.lt !== undefined && cond.lt !== null && !(num < Number(cond.lt))) return false;
            if (cond.lte !== undefined && cond.lte !== null && !(num <= Number(cond.lte))) return false;
            return true;
        }

        // Condição por igualdade de resposta (padrão)
        return this.normalizeResposta(valor) === this.normalizeResposta(cond.equals);
    };

    isQuestionVisible = (question, allAnswers) => {
        // show_if: AND de condições
        const conds = question.show_if;
        if (conds && conds.length > 0) {
            if (!conds.every(c => this.avaliarCondicao(c, allAnswers))) return false;
        }

        // show_if_any: OR de grupos (cada grupo é um AND) — pergunta alcançada por mais de um caminho
        const grupos = question.show_if_any;
        if (Array.isArray(grupos) && grupos.length > 0) {
            const algumGrupoOk = grupos.some(grupo =>
                Array.isArray(grupo) && grupo.length > 0 && grupo.every(c => this.avaliarCondicao(c, allAnswers))
            );
            if (!algumGrupoOk) return false;
        }

        // show_if_count: regras de contagem/limiar (ex.: negativa automática se < N respostas "sim")
        if (!this.avaliarShowIfCount(question, allAnswers)) return false;

        return true;
    };

    getVisibleQuestions = (config, answers) => {
        const questions = (config?.questionario?.questions || []);
        return questions.filter(q => this.isQuestionVisible(q, answers));
    };

    getTipoArquivoQuestionario = (question) => {
        const tipoConfigurado = question?.upload_tipo || question?.tipo_arquivo || question?.arquivo_tipo || question?.upload?.tipo;
        return (typeof tipoConfigurado === 'string' && tipoConfigurado.trim()) ? tipoConfigurado.trim() : 'laudo';
    };

    extrairQuestionIdDoNomeArquivo = (nomeArquivo) => {
        const match = String(nomeArquivo || '').match(/\[qid:([^\]]+)\]/);
        return match ? match[1] : null;
    };

    isPerfilNegado = (perfisNegados = []) => {
        if (!Array.isArray(perfisNegados) || perfisNegados.length === 0) return false;

        const dados_usuario = getCurrentUser();
        const tipoUsuario = dados_usuario?.tipo_usuario || '';
        const perfisNormalizados = perfisNegados.map((p) => p === 'medico' ? 'medicos' : p);

        return perfisNormalizados.includes(tipoUsuario) ||
            (tipoUsuario === 'prestador' && perfisNormalizados.includes(dados_usuario?.prestador_categoria));
    };

    getRegrasVisualizacaoArquivosQuestionario = (configuracoesServico = {}) => {
        const questions = configuracoesServico?.questionario?.questions || [];
        const byQuestionId = {};
        const byTipo = {};

        questions.forEach((q) => {
            if (q.type !== 'file') return;

            const controlShow = q['control-show'] || q.control_show || {};
            const perfisNegados = q['deny-profiles'] || q.deny_profiles || controlShow['deny-profiles'] || controlShow.deny_profiles || [];

            if (!Array.isArray(perfisNegados) || perfisNegados.length === 0) return;

            byQuestionId[q.id] = perfisNegados;

            const tipoArquivo = this.getTipoArquivoQuestionario(q);
            byTipo[tipoArquivo] = [...new Set([...(byTipo[tipoArquivo] || []), ...perfisNegados])];
        });

        return { byQuestionId, byTipo };
    };

    podeVisualizarArquivoPorPerfil = (arquivo, configuracoesServico = {}) => {
        const regras = this.getRegrasVisualizacaoArquivosQuestionario(configuracoesServico);
        const questionId = this.extrairQuestionIdDoNomeArquivo(arquivo?.nome);

        if (questionId && this.isPerfilNegado(regras.byQuestionId[questionId] || [])) {
            return false;
        }

        const perfisNegadosPorTipo = regras.byTipo[arquivo?.tipo] || [];
        if (this.isPerfilNegado(perfisNegadosPorTipo)) {
            return false;
        }

        return true;
    };

    validarQuestionariosSelecionados = () => {
        const errosGlobais = {}; 
        const selecionados = Array.from(this.state.pre_examesSelecionados || []);
        if (selecionados.length === 0) return { ok: false, errosGlobais };

        for (const servicoId of selecionados) {
            const item = this.state.listaExamesDisponiveis.find(x => x.id === servicoId);
            const config = item?.configuracoes || {};
            const answers = this.state.respostasPorServico[servicoId] || {};
            
            const visibles = this.getVisibleQuestions(config, answers);
            const errors = {};

            for (const q of visibles) {
                if (q.required) {
                    const v = answers[q.id];
                    if(q.type === 'info' || q.type === 'block') continue;

                    const vazio = !v || (typeof v === 'string' && v.trim().length === 0);
                    if (vazio) errors[q.id] = 'Campo obrigatório.';
                }
            }

            if (Object.keys(errors).length > 0) {
                errosGlobais[servicoId] = errors;
            }
        }

        return { ok: Object.keys(errosGlobais).length === 0, errosGlobais };
    };

    // Retorna o conjunto de IDs de serviços selecionados que estão bloqueados pela elegibilidade
    // (têm alguma pergunta type:'block' visível conforme as respostas atuais).
    getServicosBloqueados = () => {
        const bloqueados = new Set();
        const selecionados = Array.from(this.state.pre_examesSelecionados || []);
        for (const servicoId of selecionados) {
            const item = this.state.listaExamesDisponiveis.find(x => x.id === servicoId);
            const config = item?.configuracoes || {};
            const answers = this.state.respostasPorServico[servicoId] || {};
            const visibleQs = this.getVisibleQuestions(config, answers);

            if (visibleQs.some(q => q.type === 'block')) {
                bloqueados.add(servicoId);
            }
        }
        return bloqueados;
    }

    // Flag de configuração do serviço: permite solicitar o exame mesmo bloqueado pela elegibilidade
    // (o pedido é criado com status 'recusado_elegibilidade' para a navegadora liberar depois).
    servicoPermiteSolicitarBloqueado = (servicoId) => {
        const item = this.state.listaExamesDisponiveis.find(x => x.id === servicoId);
        const elig = item?.configuracoes?.elegibilidade || {};
        return !!elig.permitir_solicitar_bloqueado;
    }

    verificarBloqueios = () => this.getServicosBloqueados().size > 0;

    // True quando a elegibilidade do exame foi atendida na tela de cadastro: há exame selecionado,
    // nenhum serviço bloqueado e o questionário obrigatório está completo. Só então o upload do
    // pedido de exame é exibido e exigido (se não passar a elegibilidade, o campo nem aparece).
    elegibilidadePassouCadastro = () => {
        const temSelecao = (this.state.pre_examesSelecionados?.size || 0) > 0;
        if (!temSelecao) return false;
        if (this.getServicosBloqueados().size > 0) return false;
        return this.validarQuestionariosSelecionados().ok;
    };

    // Renderiza as perguntas visíveis agrupadas por seção. Cada pergunta pode ter um campo
    // `secao` (string) no JSON do questionário; quando a seção muda, injeta um cabeçalho (título
    // em destaque) e, a partir da segunda seção, uma linha separadora acima. Perguntas sem `secao`
    // (ex.: info de introdução, block de inelegibilidade) renderizam sem cabeçalho.
    renderQuestoesComSecoes = (visibleQs, servicoId, answers) => {
        const elementos = [];
        let secaoAtual = null;
        let jaRenderouSecao = false;

        visibleQs.forEach(q => {
            const secao = (q.secao || '').trim();
            if (secao && secao !== secaoAtual) {
                elementos.push(
                    <Col sm={12} key={`secao_${servicoId}_${secao}`} className="mb-1">
                        {jaRenderouSecao && (
                            <hr style={{ borderTop: '2px solid #dc3545', opacity: 0.6, margin: '0.25rem 0 1rem' }} />
                        )}
                        <h5 className="fw-bold text-danger mb-2" style={{ fontSize: '1.05rem' }}>{secao}</h5>
                    </Col>
                );
                secaoAtual = secao;
                jaRenderouSecao = true;
            }

            elementos.push(
                <Col key={q.id} sm={q.col || 12} className="mb-3">
                    {q.type !== 'info' && q.type !== 'block' && (
                        <Form.Label className="mb-1">
                            {q.label} {q.required && <span className="text-danger">*</span>}
                        </Form.Label>
                    )}
                    {this.renderQuestionInput(q, servicoId, answers)}
                    {this.state.validacaoErros[q.id] && (
                        <div className="text-danger small mt-1">
                            <FaExclamationTriangle className="me-1"/>
                            {this.state.validacaoErros[q.id]}
                        </div>
                    )}
                </Col>
            );
        });

        return elementos;
    };

    renderQuestionInput = (q, servicoId, answers) => {
        const hasError = !!this.state.validacaoErros[q.id];

        switch(q.type) {
            case 'info':
                return (
                    <Alert variant="info" className="d-flex align-items-center p-2">
                        <FaInfoCircle className="me-2 fs-4" />
                        <div>{q.label}</div>
                    </Alert>
                );
            case 'block': {
                // Link de suporte por WhatsApp na mensagem de inelegibilidade. Número e mensagem são
                // configuráveis (na pergunta block ou em configuracoes.elegibilidade do serviço /
                // configuracoes de exames do programa); enquanto não houver número real, usa um fake.
                const itemBloqueio = this.state.listaExamesDisponiveis.find(x => x.id === servicoId);
                const eligBloqueio = itemBloqueio?.configuracoes?.elegibilidade || {};
                const whatsappRaw = q.whatsapp || eligBloqueio.whatsapp_suporte || this.getConfigExames('whatsapp_suporte', '') || '5511999999999';
                const whatsappNum = String(whatsappRaw).replace(/\D/g, '');
                const whatsappMsg = q.whatsapp_mensagem || eligBloqueio.whatsapp_mensagem || 'Olá, preciso de ajuda com a elegibilidade do exame.';
                const whatsappUrl = `https://wa.me/${whatsappNum}?text=${encodeURIComponent(whatsappMsg)}`;
                return (
                    <Alert variant="danger" className="p-2">
                        <div className="d-flex align-items-center">
                            <FaBan className="me-2 fs-4" />
                            <div>{q.label}</div>
                        </div>
                        {whatsappNum && (
                            <div className="mt-2">
                                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn btn-success btn-sm">
                                    <FaWhatsapp className="me-1" /> Falar com o suporte no WhatsApp
                                </a>
                            </div>
                        )}
                    </Alert>
                );
            }
            case 'file':
                return (
                    <>
                        <Form.Control 
                            type="file" 
                            accept=".pdf,.jpg,.jpeg,.png"
                            isInvalid={hasError}
                            onChange={(e) => this.onChangeArquivoDinamico(servicoId, q.id, e)}
                        />
                        {this.state.arquivosDinamicos[`${servicoId}_${q.id}`] && (
                            <small className="text-success d-block mt-1">
                                Arquivo selecionado: {this.state.arquivosDinamicos[`${servicoId}_${q.id}`].name}
                            </small>
                        )}
                    </>
                );
            case 'yes_no':
                return (
                    <div>
                        <Form.Check
                            inline type="radio"
                            name={`q_${servicoId}_${q.id}`}
                            id={`q_${servicoId}_${q.id}_sim`}
                            label="Sim"
                            checked={(answers[q.id] || '') === 'sim'}
                            onChange={() => this.onChangeResposta(servicoId, q.id, 'sim')}
                            isInvalid={hasError}
                        />
                        <Form.Check
                            inline type="radio"
                            name={`q_${servicoId}_${q.id}`}
                            id={`q_${servicoId}_${q.id}_nao`}
                            label="Não"
                            checked={(answers[q.id] || '') === 'nao'}
                            onChange={() => this.onChangeResposta(servicoId, q.id, 'nao')}
                            isInvalid={hasError}
                        />
                    </div>
                );
            case 'radio':
                return (
                    <div>
                        {(q.options || []).map((opt) => {
                            const value = (opt && typeof opt === 'object') ? opt.value : opt;
                            const label = (opt && typeof opt === 'object') ? (opt.label ?? opt.value) : opt;
                            return (
                                <Form.Check
                                    key={value}
                                    inline type="radio"
                                    name={`q_${servicoId}_${q.id}`}
                                    id={`q_${servicoId}_${q.id}_${value}`}
                                    label={label}
                                    checked={(answers[q.id] || '') === value}
                                    onChange={() => this.onChangeResposta(servicoId, q.id, value)}
                                    isInvalid={hasError}
                                />
                            );
                        })}
                    </div>
                );
            case 'select':
                return (
                    <Form.Control
                        as="select"
                        value={answers[q.id] || ''}
                        isInvalid={hasError}
                        onChange={(e) => this.onChangeResposta(servicoId, q.id, e.target.value)}
                    >
                        <option value="">Selecione...</option>
                        {(q.options || []).map((opt) => {
                            const value = (opt && typeof opt === 'object') ? opt.value : opt;
                            const label = (opt && typeof opt === 'object') ? (opt.label ?? opt.value) : opt;
                            return <option key={value} value={value}>{label}</option>;
                        })}
                    </Form.Control>
                );
            case 'date':
                return (
                    <Form.Control
                        type="date"
                        value={answers[q.id] || ''}
                        onChange={(e) => this.onChangeResposta(servicoId, q.id, e.target.value)}
                        isInvalid={hasError}
                    />
                );
            case 'number':
                return (
                    <Form.Control
                        type="number"
                        placeholder={q.placeholder || ''}
                        value={answers[q.id] || ''}
                        onChange={(e) => this.onChangeResposta(servicoId, q.id, e.target.value)}
                        isInvalid={hasError}
                    />
                );
            case 'text':
            default:
                return (
                    <Form.Control
                        type="text"
                        placeholder={q.placeholder || ''}
                        value={answers[q.id] || ''}
                        onChange={(e) => this.onChangeResposta(servicoId, q.id, e.target.value)}
                        isInvalid={hasError}
                    />
                );
        }
    }

    confirmarSolicitacaoExames = async () => {
        const medico_id = this.state.medico_logado_id || this.state.exame_selecionado.medico_id;
        const MySwal = withReactContent(Swal);
        
        let pedidoIdCriado = null; 

        try {
            if (!medico_id) { mensagemAlerta('Sem médico para a solicitação.', 'warning'); return; }
            if (!this.state.pre_arquivo_upload) { mensagemAlerta('Envie o arquivo do pedido de exame.', 'warning'); return; }
            if (this.state.pre_examesSelecionados.size === 0) { mensagemAlerta('Selecione ao menos um exame.', 'warning'); return; }
            if (!this.state.possuiKit) { mensagemAlerta('Informe se possui kit para coleta (Sim/Não).', 'warning'); return; }

            if (this.state.possuiKit === 'nao') {
                const { nome, cep, endereco, numero, bairro, cidade, uf } = this.state.novoEndereco;
                if (!nome || !cep || !endereco || !numero || !bairro || !cidade || !uf) {
                    mensagemAlerta('Preencha todos os campos obrigatórios do endereço.', 'warning');
                    return;
                }
            }

            const { ok, errosGlobais } = this.validarQuestionariosSelecionados();
            if (!ok) {
                const selecionados = Array.from(this.state.pre_examesSelecionados);
                this.setState({ validacaoErros: (errosGlobais[selecionados[0]] || {}) });
                mensagemAlerta('Preencha os campos obrigatórios do questionário.', 'warning');
                return;
            }

            // Serviços bloqueados pela elegibilidade. Os que permitem "solicitar bloqueado"
            // seguem e viram 'recusado_elegibilidade'; os demais continuam travando.
            const servicosBloqueados = this.getServicosBloqueados();
            const bloqueadosSemOverride = [...servicosBloqueados].filter(id => !this.servicoPermiteSolicitarBloqueado(id));
            if (bloqueadosSemOverride.length > 0) {
                mensagemAlerta('A solicitação está bloqueada conforme regras do exame.', 'error');
                return;
            }

            const temArquivoParaEnviar = this.state.pre_arquivo_upload;
            this.setState({ loading: true });

            const form = new FormData();
            form.append('atendimento_id', this.state.atendimento_id ?? '');
            form.append('medico_id', medico_id ?? '');
            form.append('status', 'andamento_pendente_aprovacao');
            form.append('motivo', 'diagnostico');
            form.append('data_recebimento', getDataAtualLocalISO() ?? '');

            const { data: pedido } = await api.post('/exames/', form);
            pedidoIdCriado = pedido.id;

            if (this.state.pre_arquivo_upload) {
                const fdArq = new FormData();
                fdArq.append('exame_id', pedido.id);
                fdArq.append('arquivo', this.state.pre_arquivo_upload);
                await api.post('/exames/pedidos/arquivos/', fdArq);
            }

            if (this.state.possuiKit === 'nao') {
                let kitAtivo = await this.obterProgramaKitId(this.state.programa_id); // Pode dar erro (cai no catch)
                
                const payloadEndereco = { ...this.state.novoEndereco, beneficiario_id: this.props.beneficiario_id };
                const enderecoResp = await api.post('/enderecos/', payloadEndereco);
                
                await api.put(`/atendimentos/${this.state.atendimento_id}/`, { recebe_kit_paciente: true });
                
                await api.post('/atendimentos/kits/', {
                    atendimento_id: this.state.atendimento_id,
                    programa_kit_id: kitAtivo.id,
                    descricao: kitAtivo.titulo || '',
                    endereco_id: enderecoResp.data.id
                });
            }

            const enviarSolicitacaoIndividual = async (servico_procedimento_id, justificativa = null, statusInicial = null) => {
                const item = this.state.listaExamesDisponiveis.find(x => x.id === servico_procedimento_id);
                const config = item?.configuracoes || {};
                const answers = this.state.respostasPorServico[servico_procedimento_id] || {};
                const visibleQs = this.getVisibleQuestions(config, answers);
                
                const questionarioPayload = visibleQs.map(q => ({
                    id: q.id, label: q.label, type: q.type, value: answers[q.id] ?? null
                }));

                const fEx = new FormData();
                fEx.append('atendimento_id', this.state.atendimento_id ?? '');
                fEx.append('exame_id', pedido.id);
                fEx.append('servico_procedimento_id', servico_procedimento_id);
                fEx.append('necessita_motorista', false);
                fEx.append('provedor_credenciado', true);

                if (statusInicial) fEx.append('status', statusInicial);

                if (justificativa) fEx.append('justificativa_limite', justificativa);

                //existindo agendamento do mesmo serviço ainda sem exame, quem decide se
                //aproveita ou cria outro é a operação, não o sistema
                const vincular = await this.perguntarVinculoAgendamentoExistente(servico_procedimento_id, item?.nome);
                if (vincular !== null) fEx.append('vincular_agendamento_existente', vincular);

                fEx.append('questionario', JSON.stringify({
                    version: config?.questionario?.version || 1,
                    answers: questionarioPayload
                }));

                try {
                    const responseSolicitado = await api.post('/exames/solicitados/', fEx);
                    const exameSolicitadoId = responseSolicitado.data.id;

                    for (const q of visibleQs) {
                        if (q.type === 'file') {
                            const fileObj = this.state.arquivosDinamicos[`${servico_procedimento_id}_${q.id}`];
                            if (fileObj) {
                                const fdDyn = new FormData();
                                fdDyn.append('arquivo', fileObj);
                                fdDyn.append('nome', `Doc: ${q.label} [qid:${q.id}] - Exame #${exameSolicitadoId}`);
                                fdDyn.append('tipo', this.getTipoArquivoQuestionario(q));
                                fdDyn.append('data', new Date().toISOString());
                                fdDyn.append('exame_solicitado_id', exameSolicitadoId);
                                
                                await api.post('/agendamentos/arquivos/', fdDyn);
                            }
                        }
                    }
                    
                    /*if (temArquivoParaEnviar) {
                        const fdMain = new FormData();
                        fdMain.append('arquivo', temArquivoParaEnviar);
                        fdMain.append('nome', `Laudo Principal - Exame #${exameSolicitadoId}`);
                        fdMain.append('tipo', 'laudo');
                        fdMain.append('data', new Date().toISOString());
                        fdMain.append('exame_solicitado_id', exameSolicitadoId);
                        await api.post('/agendamentos/arquivos/', fdMain);
                    }*/

                    return true;

                } catch (error) {
                    if (error.response && error.response.status === 400) {
                        const { data } = error.response;

                        if (data.limite_confirmacao) {
                            this.setState({ loading: false });
                            const result = await MySwal.fire({
                                icon: 'warning',
                                title: `Limite: ${item.nome}`,
                                text: data.message,
                                input: 'textarea',
                                inputLabel: 'Justificativa',
                                showCancelButton: true,
                                confirmButtonText: 'Confirmar',
                                cancelButtonText: 'Cancelar Solicitação', // Cancelar aborta tudo
                                inputValidator: (v) => !v && 'Escreva uma justificativa!'
                            });

                            if (result.isConfirmed) {
                                this.setState({ loading: true });
                                return await enviarSolicitacaoIndividual(servico_procedimento_id, result.value, statusInicial);
                            } else {
                                throw new Error('CANCELADO_PELO_USUARIO');
                            }
                        }
                        
                        if (data.limite_validacao) {
                            this.setState({ loading: false });
                            await MySwal.fire({ icon: 'error', title: 'Bloqueado', html: data.limite_validacao });
                            throw new Error('BLOQUEIO_VALIDACAO');
                        }
                    }
                    throw error;
                }
            };

            let houveRecusadoElegibilidade = false;
            for (const servico_id of this.state.pre_examesSelecionados) {
                const recusadoElegibilidade = servicosBloqueados.has(servico_id);
                if (recusadoElegibilidade) houveRecusadoElegibilidade = true;
                await enviarSolicitacaoIndividual(servico_id, null, recusadoElegibilidade ? 'recusado_elegibilidade' : null);
            }

            /*await MySwal.fire({
                icon: 'success',
                title: 'Pedido de exame enviado!',
                text: 'O time do programa Raros em Foco dará continuidade ao agendamento do exame.',
                confirmButtonText: 'OK'
            });*/

            await this.getExames();
            this.handleFecharPreSolicitacao();
            
            // Verifica se os exames solicitados são APENAS os extras
            const extraExamsList = this.props.exames_extras_solicitacao || [];
            const selecionados = Array.from(this.state.pre_examesSelecionados);
            const isApenasExtras = selecionados.length > 0 && selecionados.every(id => extraExamsList.map(String).includes(String(id)));
            
            // Verifica configuração para pular etapa
            let forceSkip = false;
            for (const servico_id of selecionados) {
                const item = this.state.listaExamesDisponiveis.find(x => x.id === servico_id);
                const config = (item?.configuracoes?.['Exames_Component'] || item?.configuracoes) || {};
                
                if (config.atendimento_etapa_update) {
                    const targetEtapa = config.se_etapa_for;
                    
                    if (Array.isArray(targetEtapa)) {
                        if (targetEtapa.includes(this.props.etapa_nome)) {
                            forceSkip = true;
                        }
                    } else if (targetEtapa === this.props.etapa_nome) {
                        forceSkip = true;
                    }
                }
            }
            
            // Se for apenas exames extras, NÃO avança a etapa (passa false), a menos que forçado.
            // E se algum exame caiu na validação de elegibilidade (recusado_elegibilidade),
            // também NÃO avança a etapa automaticamente — a navegadora precisa liberar antes.
            const avancar = (forceSkip || !isApenasExtras) && !houveRecusadoElegibilidade;

            if (this.props.onExamesSolicitadosSucesso) {
                this.props.onExamesSolicitadosSucesso(avancar, forceSkip);
            }

        } catch (e) {
            console.error("Erro no fluxo:", e);
            
            if (pedidoIdCriado) {
                console.error("Realizando Rollback do Pedido...", pedidoIdCriado);
                try {
                    await api.delete(`/exames/${pedidoIdCriado}/`);
                } catch (errRollback) {
                    console.error("Erro ao realizar rollback", errRollback);
                }
            }

            if (e.message !== 'CANCELADO_PELO_USUARIO') {
                let msg = 'Erro ao criar solicitação.';
                if (e.response?.data) {
                    const vals = Object.values(e.response.data);
                    if (vals.length) msg = Array.isArray(vals[0]) ? vals[0][0] : (vals[0]?.message || JSON.stringify(vals[0]));
                } else if (e.message === 'BLOQUEIO_VALIDACAO') {
                    msg = 'Solicitação bloqueada por regras do programa.';
                }
                
                mensagemAlerta(msg, 'error');
            }
        } finally {
            this.setState({ loading: false });
        }
    }

    onSelecionarExamePre = (id) => {
        this.setState({
            pre_examesSelecionados: new Set([id]),
            validacaoErros: {},
            respostasPorServico: { ...this.state.respostasPorServico, [id]: {} }
        });
    };

    handleChangeNovoEndereco = (e) => {
        const { name, value } = e.target;
        this.setState(prev => ({
            novoEndereco: { ...prev.novoEndereco, [name]: value }
        }));
    };

    onChangeCepNovoEndereco = (e) => {
        const raw = e.target.value || '';
        const cep = raw.replace(/\D/g, '').slice(0, 8); // só dígitos, máx 8

        this.setState(prev => ({
            novoEndereco: { ...prev.novoEndereco, cep }
        }), async () => {
            if (cep.length === 8) {
            try {
                const { data } = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
                if (!data.erro) {
                this.setState(prev => ({
                    novoEndereco: {
                    ...prev.novoEndereco,
                    endereco: data.logradouro || '',
                    bairro: data.bairro || '',
                    cidade: data.localidade || '',
                    uf: data.uf || '',
                    }
                }));
                }
            } catch (err) {
                // silencioso; usuário pode preencher manualmente
            }
            }
        });

        this.handleChangeNovoEndereco(e);
    };


    getConfigDoExameSelecionado = () => {
        const selecionados = Array.from(this.state.pre_examesSelecionados || []);
        if (selecionados.length === 0) return null;
        const servicoId = selecionados[0]; // radio -> sempre um
        const item = this.state.listaExamesDisponiveis.find(x => x.id === servicoId);
        return item?.configuracoes || null;
    };

    validarQuestionarioDoServico = (servicoId, config, answers) => {
        const errors = {};
        const visibles = this.getVisibleQuestions(config, answers);
        for (const q of visibles) {
            if (q.required) {
            const v = answers[q.id];
            const vazio = (q.type === 'text')
                ? !(v && String(v).trim().length > 0)
                : !(v === 'sim' || v === 'nao');
            if (vazio) errors[q.id] = 'Campo obrigatório.';
            }
        }
        return errors;
    };
 

    parseQuestionario = (q) => {
        if (!q) return null;
        try { return (typeof q === 'string') ? JSON.parse(q) : q; }
        catch { return null; }
    };

    fmtValorResposta = (ans) => {
        if (ans == null || ans === '') return '—';
        const s = String(ans).toLowerCase();
        if (s === 'sim') return 'Sim';
        if (s === 'nao') return 'Não';
        return String(ans);
    };

    // Retorna o ID do kit ativo do programa ou lança erro
    obterProgramaKitId = async (programa_id) => {
        if (!programa_id) throw new Error('programa_id é obrigatório');

        const resp = await api.get('/programas/kits/', {
            params: { programa_id: programa_id, status: 1, limit: 1 }
        });

        const lista = Array.isArray(resp.data?.results)
            ? resp.data.results
            : (Array.isArray(resp.data) ? resp.data : []);

        if (!lista.length) throw new Error('Nenhum kit ativo encontrado para o programa.');

        return lista[0];
    }

    buscarConsultorPorEstado = async (ufRaw) => {
        try {
            // normaliza UF (tira espaços e coloca em maiúsculo)
            const uf = (ufRaw || '').trim().toUpperCase();

            const { consultoresPorEstado } = this.state;

            // se já tem no cache, só retorna
            if (consultoresPorEstado[uf]) {
                return consultoresPorEstado[uf];
            }

            const response = await api.get("/consultores", {
                params: {
                    programa_id: this.state.programa_id,  // garante que tem esse state
                    estado: uf
                }
            });

            // se vier no formato paginado (count, results, etc)
            const lista = Array.isArray(response.data)
                ? response.data
                : (response.data?.results || []);

            const primeiro = lista.length > 0 ? lista[0] : null;

            // só pra depurar, se quiser:

            // salva no cache
            this.setState(prev => ({
                consultoresPorEstado: {
                    ...prev.consultoresPorEstado,
                    [uf]: primeiro
                }
            }));

            return primeiro;

        } catch (err) {
            console.error("Erro carregando consultor UF:", ufRaw, err);
            return null;
        }
    };

    carregarConsultores = async () => {
        const lista = this.state.exames?.results || [];
        const ufs = [...new Set(lista.map(ex => ex.dados_medico.registro_uf).filter(Boolean))];

        for (const uf of ufs) {
            await this.buscarConsultorPorEstado(uf);
        }
    };

    podeVisualizarCampo = (campo) => {
        if (!campo['control-show']) {
            return true;
        }

        const controlShow = campo['control-show'];
        const dados_usuario = getCurrentUser();
        const tipoUsuario = dados_usuario?.tipo_usuario || '';

        // Se tem allow-profiles, mostra APENAS para os perfis listados
        if (controlShow['allow-profiles'] && Array.isArray(controlShow['allow-profiles'])) {
            return controlShow['allow-profiles'].includes(tipoUsuario);
        }

        // Se tem deny-profiles, mostra para todos EXCETO os perfis listados
        if (controlShow['deny-profiles'] && Array.isArray(controlShow['deny-profiles'])) {
            const isDenied = controlShow['deny-profiles'].includes(tipoUsuario) || 
                            (tipoUsuario === 'prestador' && controlShow['deny-profiles'].includes(dados_usuario['prestador_categoria']));
            return !isDenied;
        }

        return true;
    }

    renderDynamicData = (dataSource, title, camposConfig = [], agendamento = null) => {
        if (!dataSource) return null;

        let itemsToRender = [];

        if (Array.isArray(dataSource)) {
            itemsToRender = dataSource.filter(item => {
                if (!camposConfig || camposConfig.length === 0) return true;
                const config = camposConfig.find(c => c.slug === item.slug);
                return config ? this.podeVisualizarCampo(config) : true;
            }).map(item => ({
                label: item.label || item.slug,
                value: item.value,
                type: item.type
            }));
        } 
        else if (typeof dataSource === 'object') {
            const valuesObj = dataSource.valores || dataSource;
            
            if (Array.isArray(valuesObj)) {
                itemsToRender = valuesObj.map(item => ({
                    label: item.label || item.slug,
                    value: item.value,
                    type: item.type
                }));
            } else {
                Object.entries(valuesObj).forEach(([slug, valor]) => {
                    if (valor === null || valor === undefined || valor === '' || typeof valor === 'object') return;

                    const config = camposConfig.find(c => c.slug === slug);
                    
                    let label = slug;
                    if (config) {
                        if (!this.podeVisualizarCampo(config)) return;
                        label = config.label;
                    } else {
                        label = slug.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
                    }

                    itemsToRender.push({
                        label: label,
                        value: valor,
                        type: config?.tipo || 'text'
                    });
                });
            }
        }

       if (itemsToRender.length === 0) return null;

        return (
            <div className="mb-2">
                {title && <div className="fw-bold mb-1 border-bottom pb-1">{title}</div>}
                {itemsToRender.map((item, idx) => {
                    let displayValue = item.value;

                    const isDateType = item.type === 'date' || item.type === 'datetime';
                    const looksLikeDate = typeof item.value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(item.value);
                    
                    if ((isDateType || looksLikeDate) && item.value) {
                        displayValue = moment(item.value).format('DD/MM/YYYY');
                    } else if (item.value === "true" || item.value === true) {
                        displayValue = "Sim";
                    } else if (item.value === "false" || item.value === false) {
                        displayValue = "Não";
                    }

                    return (
                        <div key={idx} className="mb-1">
                            <strong>{item.label}:</strong> <span className="ms-1">{displayValue}</span>
                        </div>
                    );
                })}
            </div>
        );
    }

    // ===== Modo inline na criação do atendimento (elegibilidade do exame em memória) =====

    carregarListaExamesDisponiveisCadastro = async () => {
        try {
            let url = `/programas/servicos_procedimentos/?status=1&programa=${this.state.programa_id}`;
            if (this.props.doenca_id) {
                url += `&doenca_id=${this.props.doenca_id}`;
            }
            const resp = await api.get(url);
            const lista = resp.data.results.map(item => ({
                id: item.servico_procedimento_id,
                nome: item.dados_servico.nome,
                configuracoes: item.dados_servico.configuracoes,
                valor: formatarValor(item.valor),
                ocultar_solicitacao_exames: item.dados_servico.ocultar_solicitacao_exames
            }));
            this.setState({ listaExamesDisponiveis: lista });
        } catch (e) {
            console.error(e);
            mensagemAlerta('Erro ao carregar exames disponíveis', 'error');
        }
    };

    // Avalia a elegibilidade em memória e avisa o pai (AtendimentosEdit) para liberar/bloquear o paciente.
    notificarElegibilidadeCadastro = () => {
        const temSelecao = (this.state.pre_examesSelecionados?.size || 0) > 0;
        const temPedido = !!this.state.pre_arquivo_upload;
        const bloqueado = this.getServicosBloqueados().size > 0;
        const { ok: completo } = this.validarQuestionariosSelecionados();

        let status = 'pendente';
        if (temSelecao && bloqueado) status = 'recusado';
        else if (temSelecao && temPedido && completo) status = 'elegivel';

        if (this.props.onElegibilidadeCadastroChange) {
            this.props.onElegibilidadeCadastroChange({ status, bloqueado, temSelecao, temPedido, completo });
        }
    };

    // Cria o pedido de exame a partir do que está em memória, usando o atendimento recém-criado.
    // Não recarrega nem avança etapa. Retorna { ok, recusado }.
    submitPedidoCadastro = async (atendimentoId) => {
        const medico_id = this.state.medico_logado_id || this.state.exame_selecionado.medico_id;
        if (!atendimentoId) return { ok: false };
        if (!medico_id) { mensagemAlerta('Sem médico para a solicitação.', 'warning'); return { ok: false }; }
        if (this.state.pre_examesSelecionados.size === 0) { mensagemAlerta('Selecione ao menos um exame.', 'warning'); return { ok: false }; }

        const { ok } = this.validarQuestionariosSelecionados();
        if (!ok) { mensagemAlerta('Preencha os campos obrigatórios do questionário.', 'warning'); return { ok: false }; }

        const servicosBloqueados = this.getServicosBloqueados();
        const bloqueadosSemOverride = [...servicosBloqueados].filter(id => !this.servicoPermiteSolicitarBloqueado(id));
        if (bloqueadosSemOverride.length > 0) { mensagemAlerta('A solicitação está bloqueada conforme regras do exame.', 'error'); return { ok: false }; }

        // O arquivo do pedido só é exigido quando a elegibilidade passa (caso elegível). No caso
        // recusado (todos os exames selecionados bloqueados com override), o upload nem aparece na tela,
        // então é opcional aqui.
        const selecionadosArr = Array.from(this.state.pre_examesSelecionados);
        const todosBloqueados = selecionadosArr.length > 0 && selecionadosArr.every(id => servicosBloqueados.has(id));
        if (!todosBloqueados && !this.state.pre_arquivo_upload) { mensagemAlerta('Envie o arquivo do pedido de exame.', 'warning'); return { ok: false }; }

        // Cabeçalho do pedido
        const form = new FormData();
        form.append('atendimento_id', atendimentoId);
        form.append('medico_id', medico_id);
        form.append('status', 'andamento_pendente_aprovacao');
        form.append('motivo', 'diagnostico');
        form.append('data_recebimento', getDataAtualLocalISO() ?? '');
        const { data: pedido } = await api.post('/exames/', form);

        // Arquivo do pedido médico (opcional no caso recusado, em que o upload não é exibido)
        if (this.state.pre_arquivo_upload) {
            const fdArq = new FormData();
            fdArq.append('exame_id', pedido.id);
            fdArq.append('arquivo', this.state.pre_arquivo_upload);
            await api.post('/exames/pedidos/arquivos/', fdArq);
        }

        let houveRecusado = false;
        for (const servico_id of this.state.pre_examesSelecionados) {
            const recusado = servicosBloqueados.has(servico_id);
            if (recusado) houveRecusado = true;

            const item = this.state.listaExamesDisponiveis.find(x => x.id === servico_id);
            const config = item?.configuracoes || {};
            const answers = this.state.respostasPorServico[servico_id] || {};
            const visibleQs = this.getVisibleQuestions(config, answers);
            const questionarioPayload = visibleQs.map(q => ({ id: q.id, label: q.label, type: q.type, value: answers[q.id] ?? null }));

            const fEx = new FormData();
            fEx.append('atendimento_id', atendimentoId);
            fEx.append('exame_id', pedido.id);
            fEx.append('servico_procedimento_id', servico_id);
            fEx.append('necessita_motorista', false);
            fEx.append('provedor_credenciado', true);
            if (recusado) fEx.append('status', 'recusado_elegibilidade');
            fEx.append('questionario', JSON.stringify({ version: config?.questionario?.version || 1, answers: questionarioPayload }));

            const resp = await api.post('/exames/solicitados/', fEx);
            const exameSolicitadoId = resp.data.id;

            for (const q of visibleQs) {
                if (q.type === 'file') {
                    const fileObj = this.state.arquivosDinamicos[`${servico_id}_${q.id}`];
                    if (fileObj) {
                        const fdDyn = new FormData();
                        fdDyn.append('arquivo', fileObj);
                        fdDyn.append('nome', `Doc: ${q.label} [qid:${q.id}] - Exame #${exameSolicitadoId}`);
                        fdDyn.append('tipo', this.getTipoArquivoQuestionario(q));
                        fdDyn.append('data', new Date().toISOString());
                        fdDyn.append('exame_solicitado_id', exameSolicitadoId);
                        await api.post('/agendamentos/arquivos/', fdDyn);
                    }
                }
            }
        }
        return { ok: true, recusado: houveRecusado };
    };

    renderModoCadastro = (dados_usuario) => {
        const isMedicoLogado = !!this.state.medico_logado_id;
        const nomenclatura = this.getConfigExames('nomenclatura', 'Exames');
        return (
            <div className="border rounded p-3 mb-3 bg-white">
                <h6 className="mb-3 text-primary"><FaFileAlt className="me-2"/>Avaliação de elegibilidade do {nomenclatura}</h6>
                <Row>
                    {!isMedicoLogado && (
                        <Col sm={6} xs={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Médico</Form.Label>
                                <AsyncSelect
                                    key={this.state.focusMedico}
                                    loadOptions={(inputValue) => new Promise((resolve) => {
                                        clearTimeout(this.medicoSearchTimeout);
                                        this.medicoSearchTimeout = setTimeout(() => resolve(this.carregarMedicos(inputValue)), 700);
                                    })}
                                    onFocus={() => this.setState({ focusMedico: true })}
                                    openMenuOnFocus={this.state.focusMedico}
                                    defaultOptions
                                    onChange={e => this.handleChangeExame(e, 'medico_id')}
                                    placeholder="Buscar médico..."
                                    noOptionsMessage={() => "Nenhum médico encontrado"}
                                    value={this.state.exame_selecionado.medico_id ? { value: this.state.exame_selecionado.medico_id, label: this.state.exame_selecionado.medico_nome } : null}
                                />
                            </Form.Group>
                        </Col>
                    )}
                    <Col sm={12}>
                        <Form.Label>Selecione o {nomenclatura} <span className="text-danger">*</span></Form.Label>
                        <div className="border rounded p-2" style={{ maxHeight: 320, overflowY: 'auto' }}>
                            {(() => {
                                const listaFiltrada = this.state.listaExamesDisponiveis.filter(item => {
                                    if (item.ocultar_solicitacao_exames) return false;
                                    const config = item.configuracoes || {};
                                    const regraOcultacao = config['oculta-selecao-on-solicitar-exames'];
                                    if (regraOcultacao && regraOcultacao['deny-profiles']) {
                                        const perfisNegados = regraOcultacao['deny-profiles'];
                                        const isMedico = dados_usuario['prestador_categoria'] === 'medicos';
                                        const isOperador = dados_usuario['tipo_usuario'] === 'operador';
                                        if (isMedico && perfisNegados.includes('medico')) return false;
                                        if (isOperador && perfisNegados.includes('operador')) return false;
                                    }
                                    return true;
                                });
                                if (listaFiltrada.length === 0) return <p className="text-muted mb-0">Não há exames disponíveis para solicitação</p>;
                                return listaFiltrada.map(item => (
                                    <Form.Check
                                        key={item.id}
                                        type={this.props.habilitar_selecionar_multiplos_exames ? "checkbox" : "radio"}
                                        name="exame_pre_cad"
                                        id={`exame_pre_cad_${item.id}`}
                                        label={item.nome}
                                        checked={this.state.pre_examesSelecionados.has(item.id)}
                                        onChange={() => this.toggleExamePre(item.id)}
                                        className="mb-1"
                                    />
                                ));
                            })()}
                        </div>
                        {(() => {
                            const selecionados = Array.from(this.state.pre_examesSelecionados || []);
                            if (selecionados.length === 0) return null;
                            return selecionados.map((servicoId) => {
                                const item = this.state.listaExamesDisponiveis.find(x => x.id === servicoId);
                                const config = item?.configuracoes || {};
                                const answers = this.state.respostasPorServico[servicoId] || {};
                                const visibleQs = this.getVisibleQuestions(config, answers);
                                if (visibleQs.length === 0) return null;
                                return (
                                    <div key={servicoId} className="mt-3 border rounded p-3 bg-light">
                                        <h6 className="mb-3 text-primary"><FaFileAlt className="me-2"/>Informações adicionais: <strong>{item.nome}</strong></h6>
                                        <Row>
                                        {this.renderQuestoesComSecoes(visibleQs, servicoId, answers)}
                                        </Row>
                                    </div>
                                );
                            });
                        })()}

                        {/* Upload do pedido de exame: só aparece (e é obrigatório) depois que a
                            elegibilidade passa. Se o exame for bloqueado/incompleto, o campo nem aparece. */}
                        {this.elegibilidadePassouCadastro() && (
                            <div className="mt-3">
                                <Form.Label>Pedido de {nomenclatura} (.pdf,.doc,.docx,.jpg,.jpeg,.png) <span className="text-danger">*</span></Form.Label>
                                <Form.Control type="file" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" onChange={this.onChangeArquivoPre} />
                                {this.state.pre_arquivo_upload && (
                                    <small className="text-muted d-block mt-1">Arquivo selecionado: {this.state.pre_arquivo_upload.name}</small>
                                )}
                            </div>
                        )}
                    </Col>
                </Row>
            </div>
        );
    };

    render() {
        const dados_usuario = getCurrentUser();

        // Modo inline (elegibilidade do exame na tela de criação do atendimento)
        if (this.props.modoCadastro) {
            return this.renderModoCadastro(dados_usuario);
        }

        const results = this.state.exames?.results || [];
        const temExames = Array.isArray(results) && results.length > 0;
        const todosRecusados = temExames && results.every(e => String(e.status).toLowerCase() === 'recusado');

        const extraExamsList = this.props.exames_extras_solicitacao || [];
        const statusIgnorados = ['realizado', 'cancelado', 'recusado'];
        const examesSolicitadosIds = [];

        if (temExames) {
            results.forEach(pedido => {
                (pedido.exames_solicitados || []).forEach(exame => {
                    if (exame.servico_procedimento_id && !statusIgnorados.includes(exame.status)) {
                        examesSolicitadosIds.push(exame.servico_procedimento_id);
                    }
                });
            });
        }

        const temExtrasPendentes = extraExamsList.some(extraId => !examesSolicitadosIds.includes(extraId));

        // Há um pedido ainda em andamento (algum exame solicitado fora dos status finalizados:
        // realizado/cancelado/recusado). Enquanto houver, o médico não pode abrir um novo pedido.
        const temPedidoPendente = temExames && results.some(pedido =>
            (pedido.exames_solicitados || []).some(ex => !statusIgnorados.includes(String(ex.status).toLowerCase()))
        );

        let configuracoes = this.props.programa_dados?.configuracoes;

        if (typeof configuracoes === 'string') {
            try { configuracoes = JSON.parse(configuracoes); } catch (e) { configuracoes = {}; }
        }
        
        configuracoes = configuracoes || {};

        const configExames = configuracoes['Exames_Component'] || {};
        const configMensagem = configExames['mensagem_novas_solicitacoes_exames'] || {};

        const HabilitaBotaoSolicitarMedico = configExames['botao_solicitar_exames_habilitado_sempre_pro_medico'] || {};

        const mensagemTexto = configMensagem['descricao'] || configMensagem['descrição'];
        const motivoHabilitado = configExames['Motivo_do_Exame']?.includes('habilitado');

        const dataDeAgendamentoHabilitado = configExames['data_de_agendamento']?.includes('habilitado');
        const dataAgendadaObrigatorio = configExames['data_agendada']?.includes('obrigatorio');
        const dataDeAgendamentoObrigatorio = configExames['data_de_agendamento']?.includes('obrigatorio');

        const configModalCheckbox = configExames['change_modal_exames_to_checkbox']?.includes('true');
        const tipoUsuario = dados_usuario['tipo_usuario']; // 'operador', '', etc.
        const isMedico = !!this.state.medico_logado_id;

        const mensagemNovaSolicitacao = configExames?.mensagem_solicitacao_exame;

        let usarNovoFluxo = false;

        if (isMedico) {
            usarNovoFluxo = true;
        } else if (configModalCheckbox) {
            usarNovoFluxo = configModalCheckbox;
        } else {
            usarNovoFluxo = false;
        }
        
        return (
            <>
                <Card className="cardDestaque mt-4">
                    <Card.Body>
                        <Row className="align-items-center mb-3">
                            <Col sm={6} lg={6}>
                                <h6><strong>Pedidos de {this.getConfigExames('nomenclatura', 'Exames')}</strong></h6>
                            </Col>
                            <Col sm={6} lg={6} className="text-end">
                                {this.state.medico_logado_id ? (
                                    <>
                                    {Array.isArray(this.state.exames?.results) && !temPedidoPendente && (!temExames || todosRecusados || temExtrasPendentes || HabilitaBotaoSolicitarMedico) && (
                                        <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={this.handleAbrirPreSolicitacao}>
                                            {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : `Solicitar ${this.getConfigExames('nomenclatura', 'Exames')}`}
                                        </Button>
                                    )}
                                    </>
                                ) : (
                                    <>
                                        {usarNovoFluxo ? (
                                            (isMedico && temExames && !todosRecusados) ? null : (
                                                <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={this.handleAbrirPreSolicitacao}>
                                                    {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : `Adicionar Pedido de ${this.getConfigExames('nomenclatura', 'Exame')}`}
                                                </Button>
                                            )
                                        ) : (
                                            <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalExame()}>
                                                {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : `Adicionar Pedido de ${this.getConfigExames('nomenclatura', 'Exame')}`}
                                            </Button>
                                        )}
                                    </>
                                )}
                            </Col>
                        </Row>

                        {this.state.medico_logado_id && temExames && !todosRecusados && mensagemTexto && (
                            <Row>
                                <Col sm={12}>
                                    <Alert variant="info">
                                        {/* Renderiza o HTML vindo do JSON */}
                                        <div dangerouslySetInnerHTML={{ __html: mensagemTexto }} />
                                    </Alert>
                                </Col>
                            </Row>
                        )}

                        {('results' in this.state.exames && this.state.exames.results.length > 0) ? (
                            <Row>
                                <Col sm={12} lg={12}>
                                    <Table responsive className="custom-table">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                {!this.state.medico_logado_id && (
                                                <th>Médico</th>
                                                )}
                                                {!this.state.medico_logado_id && (
                                                <th>Consultor</th>
                                                )}
                                                <th>Status</th>
                                                {!this.state.medico_logado_id && (
                                                <th>Motivo do Exame</th>
                                                )}
                                                <th>Data de Recebimento</th>
                                                {/*<th>Data de Realização</th>*/}
                                                <th>Exames</th>
                                                <th>Opções</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.exames.results.map((exame, index) => {
                                                const uf = (exame.dados_medico.registro_uf || '').trim().toUpperCase();
                                                const consultor = this.state.consultoresPorEstado[uf];

                                                return (
                                                    <tr key={index}>
                                                        <td className="bg-id">#{exame.id}</td>

                                                        {!this.state.medico_logado_id && (
                                                            <td><div className="td-border">{exame.dados_medico.nome}</div></td>
                                                        )}

                                                        {!this.state.medico_logado_id && (
                                                        <td>
                                                            <div className="td-border">
                                                                {consultor ? consultor.nome : "—"}
                                                            </div>
                                                        </td>
                                                        )}
                                                        
                                                        <td>
                                                            <div className="td-border">
                                                                {statusExame[exame.status]}
                                                                {exame.motivo_recusa && (
                                                                    <p className="mb-0"><i>{exame.motivo_recusa}</i></p>
                                                                )}
                                                            </div>
                                                        </td>

                                                        {!this.state.medico_logado_id && (
                                                            <td>
                                                                <div className="td-border">
                                                                    {this.motivos_exames.find(m => m.value === exame.motivo)?.label || exame.motivo}
                                                                </div>
                                                            </td>
                                                        )}

                                                        <td>
                                                            <div className="td-border">
                                                                {exame.data_recebimento === '1900-01-01T00:00:00'
                                                                    ? "-" 
                                                                    : formataDataHoraExibicao(exame.data_recebimento)}
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <div className="td-border">
                                                                {exame.exames_solicitados.map(e => e.dados_servico_procedimento.nome).join(", ")}
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <Button variant="secondary" size="sm" className="me-2" onClick={() => this.handleShowModalExame(exame)}>
                                                                Visualizar Pedido
                                                            </Button>

                                                            {exame.arquivos && exame.arquivos.length > 0 && exame.arquivos.map(arq => (
                                                                <Button 
                                                                    key={arq.id}
                                                                    variant="outline-info" 
                                                                    size="sm" 
                                                                    title={arq.nome}
                                                                    onClick={() => window.open(arq.arquivo, '_blank')}
                                                                >
                                                                    <FaCloudDownloadAlt /> Laudo
                                                                </Button>
                                                            ))}

                                                            {(dados_usuario['gestor_id'] || dados_usuario['is_superuser']) && hasPerm('delete_exames') && exame.status !== 'realizado' && (
                                                                <Button variant="danger" size="sm" className="me-2" onClick={() => this.deletarExame(exame.id)}>
                                                                    Excluir Pedido
                                                                </Button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        ) : (
                            <p>Nenhum exame encontrado!</p>
                        )}

                    </Card.Body>
                </Card>

                <Modal show={this.state.showModalExame} onHide={this.handleCloseModalExame} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.exame_selecionado.id ? `Visualizar Pedido de ${this.getConfigExames('nomenclatura', 'Exame')}` : `Adicionar Pedido de ${this.getConfigExames('nomenclatura', 'Exame')}`}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Médico</Form.Label>
                                    {this.state.medico_logado_id ? (
                                        <p>{this.state.exame_selecionado.medico_nome}</p>
                                    ) : (
                                    <AsyncSelect
                                        key={this.state.focusMedico}
                                        loadOptions={(inputValue) => {
                                            return new Promise((resolve) => {
                                                clearTimeout(this.medicoSearchTimeout);
                                                this.medicoSearchTimeout = setTimeout(() => {
                                                    resolve(this.carregarMedicos(inputValue));
                                                }, 700);
                                            });
                                        }}
                                        onFocus={() => {
                                            this.setState({
                                                focusMedico: true
                                            });
                                        }}
                                        //autoFocus={this.state.focusMedico}
                                        openMenuOnFocus={this.state.focusMedico}
                                        required
                                        defaultOptions
                                        onChange={e => this.handleChangeExame(e, 'medico_id')}
                                        placeholder="Buscar médico..."
                                        noOptionsMessage={() => "Nenhum médico encontrado"}
                                        value={this.state.exame_selecionado.medico_id ? { value: this.state.exame_selecionado.medico_id, label: this.state.exame_selecionado.medico_nome } : null}
                                        isDisabled={this.state.exame_selecionado.status_salvo === 'realizado'}
                                    />
                                    )}
                                </Form.Group>
                            </Col>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>CRM</Form.Label>
                                    {this.state.medico_logado_id ? (
                                        <p>{this.state.exame_selecionado.medico_crm}</p>
                                    ) : (
                                        <Form.Control
                                            type="text"
                                            name="crm"
                                            value={this.state.exame_selecionado.medico_crm ? this.state.exame_selecionado.medico_crm : ""}
                                            disabled
                                        />
                                    )}
                                </Form.Group>
                            </Col>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Status do {this.getConfigExames('nomenclatura', 'Exame')}</Form.Label>
                                    {this.state.medico_logado_id ? (
                                        <p>{statusExame[this.state.exame_selecionado.status]}</p>
                                    ) : (
                                        <Form.Control 
                                            as="select" 
                                            name="status" 
                                            value={this.state.exame_selecionado.status} 
                                            required 
                                            onChange={this.handleChangeExame}>
                                            <option value="">Status</option>
                                            {this.state.statusOptions.map(opt => (<option key={opt.value} value={opt.value}>{opt.label}</option>))}
                                        </Form.Control>
                                    )}
                                </Form.Group>
                            </Col>
                            {(this.state.exame_selecionado.status === 'recusado' || this.state.exame_selecionado.status === 'cancelado' || this.state.exame_selecionado.status === 'stand_by') && (
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Motivo de Recusa</Form.Label>
                                        {this.state.medico_logado_id ? (
                                            <p>{this.state.exame_selecionado.motivo_recusa}</p>
                                        ) : (
                                            <Form.Control type="text" name="motivo_recusa" value={this.state.exame_selecionado.motivo_recusa} required onChange={this.handleChangeExame} />
                                        )}
                                    </Form.Group>
                                </Col>
                            )}
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Data de Recebimento</Form.Label>
                                    {this.state.medico_logado_id ? (
                                        <p>{formataDataHoraExibicao(this.state.exame_selecionado.data_recebimento)}</p>
                                    ) : (
                                        <Form.Control type="datetime-local" 
                                            name="data_recebimento" 
                                            required 
                                            placeholder="Data de Recebimento" 
                                            value={this.state.exame_selecionado.data_recebimento}
                                            onChange={e => this.handleChangeExame(e, 'data_recebimento')} 
                                            max={getDataAtualLocalISO()}
                                        />
                                    )}
                                </Form.Group>
                            </Col>
                            {motivoHabilitado && !this.state.medico_logado_id && (
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Motivo do Exame</Form.Label>
                                        {this.state.medico_logado_id ? (
                                            <p>{this.motivos_exames.find(motivo => motivo.value === this.state.exame_selecionado.motivo)?.label || this.state.exame_selecionado.motivo}</p>
                                        ) : (
                                            <Form.Control 
                                                as="select" 
                                                name="motivo" 
                                                value={this.state.exame_selecionado.motivo} 
                                                required 
                                                onChange={this.handleChangeExame}
                                            >
                                                <option value="">Motivo</option>
                                                {this.state.motivoOptions.map((motivo) => (
                                                    <option key={motivo.value} value={motivo.value}>{motivo.label}</option>
                                                ))}
                                                <option value="outro">Outro</option>
                                            </Form.Control>
                                        )}
                                    </Form.Group>
                                </Col>
                            )}
                            
                            {motivoHabilitado && this.state.exame_selecionado.motivo == 'outro' && (
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Motivo do Exame</Form.Label>
                                        {this.state.medico_logado_id ? (
                                            <p>{this.state.exame_selecionado.motivo_outros}</p>
                                        ) : (
                                            <Form.Control type="text" name="motivo_outros" value={this.state.exame_selecionado.motivo_outros || ''} required onChange={this.handleChangeExame} />
                                        )}
                                    </Form.Group>
                                </Col>
                            )}
                            {this.state.exame_selecionado.id && (
                            <Col sm={12} xs={12}>
                                <Form.Group className="mb-3">
                                    {this.state.medico_logado_id ? (
                                        <>
                                            <h6 className="mt-4"><FaUpload /> Arquivo de Pedido de Exame</h6>
                                        </>
                                        
                                    ) : (
                                        <>
                                            <Form.Label>Arquivos de Pedidos de Exame</Form.Label>    
                                            <br />
                                        </>
                                    )}
                                    
                                    {this.state.exame_selecionado.arquivos_pedidos && this.state.exame_selecionado.arquivos_pedidos.length > 0 && (
                                        <div className="mb-3">
                                            {this.state.exame_selecionado.arquivos_pedidos.map((arquivo, index) => (
                                                <Card key={index} className="mb-2 border">
                                                    <Card.Body className="p-3">
                                                        <Row className="align-items-center">
                                                            {!arquivo.id && (
                                                            <Col sm={4}>
                                                                <Form.Control 
                                                                    type="file" 
                                                                    onChange={(e) => this.onChangeArquivoPedido(e, index)}
                                                                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                                                />
                                                                {arquivo.nome_original && (
                                                                    <small className="text-muted">Arquivo: {arquivo.nome_original}</small>
                                                                )}
                                                            </Col>
                                                            )}
                                                            <Col sm={8}>
                                                                {arquivo.arquivo_upload && !arquivo.id && (
                                                                    <Button 
                                                                        variant="success" 
                                                                        size="sm" 
                                                                        className="me-2"
                                                                        onClick={() => this.uploadArquivoPedido(index)}
                                                                    >
                                                                        Enviar Arquivo
                                                                    </Button>
                                                                )}
                                                                {arquivo.arquivo && (
                                                                    <a 
                                                                        href={arquivo.arquivo} 
                                                                        target="_blank" 
                                                                        rel="noopener noreferrer" 
                                                                        className="btn btn-sm btn-outline-primary me-2"
                                                                    >
                                                                        <FaDownload className="me-1"/> Visualizar Arquivo
                                                                    </a>
                                                                )}
                                                                {(dados_usuario['gestor_id'] || dados_usuario['is_superuser']) && (
                                                                <Button 
                                                                    variant="outline-danger" 
                                                                    size="sm"
                                                                    onClick={() => this.excluirArquivoPedido(index)}
                                                                >
                                                                    Excluir Arquivo
                                                                    </Button>
                                                                )}
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>
                                                </Card>
                                            ))}
                                        </div>
                                    )}
                                    
                                    {!this.state.medico_logado_id && (
                                    <Button 
                                        variant="outline-primary" 
                                        size="sm"
                                        onClick={this.adicionarArquivoPedido}
                                    >
                                        + Adicionar Arquivo de Pedido
                                    </Button>
                                    )}
                                    
                                    <Form.Text id="formArquivoExameHelper" className="text-danger">{this.state.arquivoExameHelper}</Form.Text>
                                </Form.Group>
                            </Col>
                            )}
                            {!this.state.medico_logado_id && (
                            <Col sm={12} className="text-end">
                                <Button variant="success"  size="sm" onClick={this.enviaExame}>
                                    {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : (this.state.exame_selecionado.id) ? 'Atualizar Pedido de Exame' : 'Cadastrar Pedido de Exame'}
                                </Button>
                            </Col>
                            )}
                            {this.state.exame_selecionado.id && (
                                <Col sm={12}>
                                    <Form.Group className="mb-3">
                                        {this.state.medico_logado_id ? (
                                            <>
                                                <h6 className="mt-4"><FaFileAlt /> Exames Solicitados</h6>
                                            </>
                                            
                                        ) : (
                                            <>
                                                <Form.Label>Exames Solicitados</Form.Label>
                                                <AsyncSelect
                                                    key={this.state.focusExame}
                                                    loadOptions={(inputValue) => {
                                                        return new Promise((resolve) => {
                                                            clearTimeout(this.exameSearchTimeout);
                                                            this.exameSearchTimeout = setTimeout(() => {
                                                                resolve(this.carregarExames(inputValue));
                                                            }, 700);
                                                        });
                                                    }}
                                                    onFocus={() => {
                                                        this.setState({
                                                            focusExame: true
                                                        });
                                                    }}
                                                    //autoFocus={this.state.focusExame}
                                                    openMenuOnFocus={this.state.focusExame}
                                                    required
                                                    defaultOptions
                                                    isMulti
                                                    onChange={e => this.handleChangeExame(e, 'exames')}
                                                    value={
                                                        this.state.exame_selecionado.exames_solicitados.map(exame => ({
                                                            value: exame.servico_procedimento_id,
                                                            label: exame.servico_procedimento_nome
                                                        })) || null
                                                    }
                                                />
                                            </>
                                        )}
                                    </Form.Group>
                                </Col>
                            )}
                            {this.state.exame_selecionado.id && this.state.exame_selecionado.exames_solicitados.length > 0 && this.state.exame_selecionado.exames_solicitados.map((exame, index) => {
                                // Configurações do programa para exames
                                const ocultarDataAgendamento = this.getConfigExames('ocultar_data_agendamento', false);
                                const ocultarDataAgendada = this.getConfigExames('ocultar_data_agendada', false);
                                const labelDataAprovacao = this.getConfigExames('label_data_aprovacao', 'Data de Aprovação');
                                const dataRealizacaoObrigatoria = this.getConfigExames('data_realizacao_obrigatoria', false);
                                const preencherValorTransporte = this.getConfigExames('preencher_valor_transporte', false);
                                //Programas que pagam ida e volta separadamente cobram os dois trechos do
                                //mesmo exame; sem isto so existe um valor de transporte.
                                const transporteIdaVolta = this.getConfigExames('transporte_ida_volta', false);
                                const ocultarHoraDatas = this.getConfigExames('ocultar_hora_datas', false);
                                const isLoadingExame = this.state.loadingExameSolicitado[exame.id];

                                // Tipo do campo de data baseado na configuração
                                const tipoInputData = ocultarHoraDatas ? 'date' : 'datetime-local';
                                
                                // Função para formatar valor da data para exibição no input
                                const formatarDataParaInput = (valor) => {
                                    if (!valor || valor === '1900-01-01T00:00:00') return '';
                                    if (ocultarHoraDatas) {
                                        // Retorna apenas a parte da data (YYYY-MM-DD)
                                        return valor.substring(0, 10);
                                    }
                                    return valor;
                                };

                                return (
                                <Accordion 
                                    key={index}
                                    onSelect={(eventKey) => this.handleAccordionSelect(eventKey, exame, index)}
                                >
                                    <Accordion.Item
                                        eventKey={exame.id.toString()}
                                        key={exame.id}
                                    >
                                        <Accordion.Header>
                                            <strong>Exame {index + 1}: {exame.servico_procedimento_nome}</strong>
                                            {isLoadingExame && <span className="spinner-border spinner-border-sm ms-2"></span>}
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            {(() => {
                                                const q = this.parseQuestionario(exame.questionario);
                                                const answers = q?.answers || q?.questionario?.answers || [];
                                                if (!answers || answers.length === 0) return null;
                                                return (
                                                    <Card className="mb-3 bg-light border-0">
                                                        <Card.Body className="py-3">
                                                            <h6 className="mb-3">Questionário do Exame</h6>
                                                            <div className="d-flex flex-column gap-2">
                                                            {answers.map((a) => (
                                                                <div key={a.id}>
                                                                    <div className="me-2 text-muted" style={{minWidth: 260}}>{a.label}:</div>
                                                                    <p className="mb-1"><strong>{this.fmtValorResposta(a.value)}</strong></p>
                                                                </div>
                                                            ))}
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                );
                                            })()}

                                            {exame.arquivos && exame.arquivos.length > 0 && (
                                                <div className="mb-3 p-2 border rounded bg-white">
                                                    <h6 className="text-primary small"><FaFileAlt className="me-2" /> Documentos Anexados</h6>
                                                    <div className="d-flex flex-wrap gap-2">
                                                        {exame.arquivos.map((arq, i) => (
                                                            <Button 
                                                                key={arq.id || i} 
                                                                variant="outline-secondary" 
                                                                size="sm"
                                                                onClick={() => window.open(arq.arquivo, '_blank')}
                                                            >
                                                                <FaCloudDownloadAlt className="me-1"/> {arq.nome || 'Visualizar'}
                                                            </Button>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}


                                            <Card className="mb-4 border">
                                                <Card.Body>
                                                    <Row>
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Status do Exame</Form.Label>
                                                                {exame.status === 'recusado_elegibilidade' ? (
                                                                    <>
                                                                        <p className="text-danger fw-semibold mb-2">{statusExamesSelecionados['recusado_elegibilidade']}</p>
                                                                        {!this.state.medico_logado_id && (
                                                                            <>
                                                                                <Form.Check
                                                                                    type="checkbox"
                                                                                    id={`liberar_elegibilidade_${index}`}
                                                                                    name="liberar_elegibilidade"
                                                                                    label="Este caso não seguirá o fluxo padrão de elegibilidade."
                                                                                    checked={!!exame.liberar_elegibilidade}
                                                                                    onChange={e => this.handleChangeExameSolicitado(e, 'liberar_elegibilidade', index)}
                                                                                />
                                                                                {exame.liberar_elegibilidade && (
                                                                                    <div className="mt-2">
                                                                                        <Form.Label>Motivo <span className="text-danger">*</span></Form.Label>
                                                                                        <Form.Control
                                                                                            as="textarea"
                                                                                            rows={2}
                                                                                            name="motivo_status"
                                                                                            placeholder="Justifique a liberação da elegibilidade"
                                                                                            value={exame.motivo_status || ''}
                                                                                            onChange={e => this.handleChangeExameSolicitado(e, 'motivo_status', index)}
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </>
                                                                ) : this.state.medico_logado_id ? (
                                                                    <p>{statusExamesSelecionados[exame.status]}</p>
                                                                ) : (
                                                                    <Form.Control as="select" name="status" value={exame.status || ''} required onChange={e => this.handleChangeExameSolicitado(e, 'status', index)}>
                                                                        <option value="">Status</option>
                                                                        {this.state.statusOptionsExame.map(opt => (
                                                                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                                        ))}
                                                                    </Form.Control>
                                                                )}
                                                            </Form.Group>
                                                        </Col>
                                                        {(exame.status === 'aprovado' || exame.status === 'agendado' || exame.status === 'reagendado' || exame.status === 'realizado' || exame.status === 'iniciado') && !this.state.medico_logado_id && (
                                                            <Col sm={4}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>{labelDataAprovacao} <span className="text-info"><FaInfoCircle title="Data que o cliente aprovou o exame!" /></span></Form.Label>
                                                                    <Form.Control type={tipoInputData}
                                                                        name="data_aprovacao" 
                                                                        required 
                                                                        placeholder={labelDataAprovacao}
                                                                        value={formatarDataParaInput(exame.data_aprovacao)} 
                                                                        onChange={e => this.handleChangeExameSolicitado(e, 'data_aprovacao', index)} 
                                                                        max={ocultarHoraDatas ? new Date().toISOString().slice(0, 10) : new Date().toISOString().slice(0, 16)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        )}
                                                        {!ocultarDataAgendada && (exame.status === 'agendado' || exame.status === 'reagendado' || exame.status === 'realizado') && !this.state.medico_logado_id && (
                                                            <Col sm={4}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>
                                                                        Data Agendada 
                                                                        <span className="text-info me-1"><FaInfoCircle title="Data que o exame está agendado para ser realizado!" /></span>
                                                                        {dataAgendadaObrigatorio && <span className="text-danger">*</span>}
                                                                    </Form.Label>
                                                                    <Form.Control 
                                                                    type={tipoInputData} 
                                                                        name="data_agendamento" 
                                                                        required={dataAgendadaObrigatorio} 
                                                                        placeholder="Data Agendada" 
                                                                        value={formatarDataParaInput(exame.data_agendamento)} 
                                                                        onChange={e => this.handleChangeExameSolicitado(e, 'data_agendamento', index)} 
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        )}
                                                        {!ocultarDataAgendamento && (exame.status === 'agendado' || exame.status === 'reagendado' || exame.status === 'realizado') && !this.state.medico_logado_id && (
                                                            <Col sm={4}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>
                                                                        Data de Agendamento 
                                                                        <span className="text-info"><FaInfoCircle title="Data que foi feita a ação do agendamento do exame!" /></span>
                                                                        {dataDeAgendamentoObrigatorio && <span className="text-danger">*</span>}
                                                                    </Form.Label>
                                                                    <Form.Control 
                                                                        type={tipoInputData} 
                                                                        name="data_agendada" 
                                                                        required={dataDeAgendamentoObrigatorio} 
                                                                        placeholder="Data de Agendamento" 
                                                                        value={formatarDataParaInput(exame.data_agendada)} 
                                                                        onChange={e => this.handleChangeExameSolicitado(e, 'data_agendada', index)} 
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        )}
                                                        {(exame.status === 'realizado' || exame.status === 'concluido') && !this.state.medico_logado_id && (
                                                            <Col sm={4}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Data de Realização</Form.Label>
                                                                    <Form.Control type={tipoInputData} name="data_realizacao" required={dataRealizacaoObrigatoria} placeholder="Data de Realização" value={formatarDataParaInput(exame.data_realizacao)} onChange={e => this.handleChangeExameSolicitado(e, 'data_realizacao', index)} />
                                                                </Form.Group>
                                                            </Col>
                                                        )}
                                                        {exame.status === 'realizado' && exame.dados_agendamento && (
                                                            <Col sm={12} className="mb-3">
                                                                <hr className="my-3" />
                                                                <div className="mb-3">
                                                                    <h6 className="text-uppercase mb-3">Dados da Confirmação do Serviço</h6>
                                                                    
                                                                    {exame.dados_agendamento.data_realizacao && (
                                                                        <div className="mb-2">
                                                                            <strong>Data de Realização:</strong>{' '}
                                                                            <span className="ms-1">{formataDataHoraExibicao(exame.dados_agendamento.data_realizacao)}</span>
                                                                        </div>
                                                                    )}
                                                                    
                                                                    {exame.dados_agendamento.situacao && (
                                                                        <div className="mb-2">
                                                                            <strong>Situação:</strong>{' '}
                                                                            <span className="ms-1">{exame.dados_agendamento.situacao}</span>
                                                                        </div>
                                                                    )}
                                                                    
                                                                    {(() => {
                                                                        const dadosAgendamento = exame.dados_agendamento || {};
                                                                        const configuracoesRelato = exame.dados_servico_procedimento?.configuracoes || {};
                                                                        
                                                                        const camposConfig = [
                                                                            ...(configuracoesRelato?.modal_confirmacao?.campos || []),
                                                                            ...(configuracoesRelato?.formulario_dinamico_servicos_procedimentos?.campos || [])
                                                                        ];

                                                                        const isBloqueadoVisualizarLaudo = isLaudoBloqueadoParaUsuarioAtual(this.state.programa_dados?.configuracoes);
                                                                        const isBloqueadoDadosConfirmacao = isDadosConfirmacaoBloqueadosParaUsuarioAtual(this.state.programa_dados?.configuracoes);
                                                                        
                                                                        return (
                                                                            <>
                                                                                {(() => {
                                                                                    const arquivos = dadosAgendamento.arquivos || [];
                                                                                    const hasArquivos = arquivos.length > 0;
                                                                                    
                                                                                    if (!hasArquivos && dadosAgendamento.arquivo_confirmacao) {
                                                                                        return (
                                                                                            <div className="mb-2">
                                                                                                <strong>Arquivo de Confirmação:</strong> <br/>
                                                                                                {isBloqueadoVisualizarLaudo ? (
                                                                                                    <span className="text-muted mt-1 d-inline-block">
                                                                                                        <FaExclamationTriangle className="me-1 text-warning"/> Visualização bloqueada
                                                                                                    </span>
                                                                                                ) : (
                                                                                                    <a 
                                                                                                        href={dadosAgendamento.arquivo_confirmacao} 
                                                                                                        target="_blank" 
                                                                                                        rel="noopener noreferrer" 
                                                                                                        className="btn btn-sm btn-outline-primary mt-1"
                                                                                                    >
                                                                                                        <FaDownload className="me-1"/> Visualizar Arquivo
                                                                                                    </a>
                                                                                                )}
                                                                                            </div>
                                                                                        );
                                                                                    }

                                                                                    // Se tem array, filtra apenas os NÃO recusados (apenas aprovados ou pendentes?)
                                                                                    // O usuário pediu "apenas aprovado", mas geralmente mostramos pendentes tbm.
                                                                                    // No entanto, para não exibir RECUSADOS:
                                                                                    const arquivosFiltrados = arquivos.filter(arq => arq.aprovado !== false);
                                                                                    
                                                                                    if (arquivosFiltrados.length === 0) return null;

                                                                                    return (
                                                                                        <div className="mb-2">
                                                                                            <strong>{arquivosFiltrados.length > 1 ? 'Arquivos de Confirmação:' : 'Arquivo de Confirmação:'}</strong>
                                                                                            <div className="d-flex flex-wrap gap-2 mt-1">
                                                                                                {arquivosFiltrados.map((arq, idx) => (
                                                                                                    <div key={arq.id || idx}>
                                                                                                        {(() => {
                                                                                                            const bloqueadoPorLaudo = isBloqueadoVisualizarLaudo && (arq.tipo === 'laudo' || !arq.tipo);
                                                                                                            const bloqueadoPorPerfil = !this.podeVisualizarArquivoPorPerfil(arq, configuracoesRelato);
                                                                                                            const arquivoBloqueado = bloqueadoPorLaudo || bloqueadoPorPerfil;

                                                                                                            if (arquivoBloqueado) {
                                                                                                                return (
                                                                                                            <span className="text-muted d-inline-block small">
                                                                                                                <FaExclamationTriangle className="me-1 text-warning"/> {arq.nome || 'Arquivo'} (Bloqueado)
                                                                                                            </span>
                                                                                                                );
                                                                                                            }

                                                                                                            return (
                                                                                                            <a 
                                                                                                                href={arq.arquivo} 
                                                                                                                target="_blank" 
                                                                                                                rel="noopener noreferrer" 
                                                                                                                className="btn btn-sm btn-outline-primary"
                                                                                                                title={arq.nome}
                                                                                                            >
                                                                                                                <FaDownload className="me-1"/> {arq.nome || `Arquivo ${idx + 1}`}
                                                                                                            </a>
                                                                                                            );
                                                                                                        })()}
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                        </div>
                                                                                    );
                                                                                })()}
                                                                                {isBloqueadoDadosConfirmacao ? (
                                                                                    (dadosAgendamento.dados_confirmacao || dadosAgendamento.dados_formulario_dinamico_servicos || dadosAgendamento.dados_formulario_aprovacao) && (
                                                                                        <div className="text-muted small mt-2">
                                                                                            <FaExclamationTriangle className="me-1 text-warning"/> Respostas bloqueadas para o seu perfil
                                                                                        </div>
                                                                                    )
                                                                                ) : (
                                                                                    <>
                                                                                        {this.renderDynamicData(dadosAgendamento.dados_confirmacao, null, camposConfig, dadosAgendamento)}
                                                                                        {this.renderDynamicData(dadosAgendamento.dados_formulario_dinamico_servicos, "Formulário Dinâmico:", camposConfig, dadosAgendamento)}
                                                                                        {this.renderDynamicData(dadosAgendamento.dados_formulario_aprovacao, "Formulário de Aprovação:", [], dadosAgendamento)}
                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        );
                                                                    })()}
                                                                </div>
                                                            </Col>
                                                        )}
                                                        {exame.status === 'cancelado' && (
                                                            <Col sm={4}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Data de Cancelamento</Form.Label>
                                                                    <Form.Control type={tipoInputData} name="data_cancelamento" placeholder="Data de Cancelamento" value={formatarDataParaInput(exame.data_cancelamento)} onChange={e => this.handleChangeExameSolicitado(e, 'data_cancelamento', index)} />
                                                                </Form.Group>
                                                            </Col>
                                                        )}
                                                        {(exame.status === 'recusado' || exame.status === 'cancelado' || exame.status === 'stand_by') && (
                                                            <Col sm={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Motivo Status</Form.Label>
                                                                    {this.state.medico_logado_id ? (
                                                                        <p>{exame.motivo_status}</p>
                                                                    ) : (
                                                                        <Form.Control type="text" name="motivo_status" value={exame.motivo_status || ''} onChange={e => this.handleChangeExameSolicitado(e, 'motivo_status', index)} />
                                                                    )}
                                                                </Form.Group>
                                                            </Col>
                                                        )}
                                                        {!this.state.medico_logado_id && (
                                                        <>
                                                            <Col sm={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Laboratório</Form.Label>
                                                                    <AsyncSelect
                                                                        key={this.state.exame_selecionado.exames_solicitados[index].focusLaboratorio}
                                                                        loadOptions={(inputValue) => {
                                                                            return new Promise((resolve) => {
                                                                                clearTimeout(this.state.exame_selecionado.exames_solicitados[index].laboratorioSearchTimeout);
                                                                                this.state.exame_selecionado.exames_solicitados[index].laboratorioSearchTimeout = setTimeout(() => {
                                                                                    resolve(this.carregarLaboratorios(inputValue, index));
                                                                                }, 700);
                                                                            });
                                                                        }}
                                                                        onFocus={() => {
                                                                            this.setState({
                                                                                exame_selecionado: { ...this.state.exame_selecionado, exames_solicitados: this.state.exame_selecionado.exames_solicitados.map((exame, i) => i === index ? { ...exame, focusLaboratorio: true } : exame) }
                                                                            });
                                                                        }}
                                                                        //autoFocus={this.state.exame_selecionado.exames_solicitados[index].focusLaboratorio}
                                                                        openMenuOnFocus={this.state.exame_selecionado.exames_solicitados[index].focusLaboratorio}
                                                                        required
                                                                        defaultOptions
                                                                        onChange={e => this.handleChangeExameSolicitado(e, 'laboratorio_id', index)}
                                                                        value={exame.laboratorio_id ? { value: exame.laboratorio_id, label: exame.laboratorio_nome } : null}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            {exame.laboratorio_id && (
                                                                <>
                                                                    <Col sm={12}>
                                                                        <p className="mb-1"><strong>Endereço: </strong>
                                                                            {[
                                                                                exame.laboratorio_endereco,
                                                                                exame.laboratorio_numero && `, Nº ${exame.laboratorio_numero}`,
                                                                                exame.laboratorio_complemento && ` (${exame.laboratorio_complemento})`,
                                                                                exame.laboratorio_bairro && `, ${exame.laboratorio_bairro}`,
                                                                                exame.laboratorio_cidade && ` — ${exame.laboratorio_cidade}`,
                                                                                exame.laboratorio_estado && `/${exame.laboratorio_estado}`,
                                                                                exame.laboratorio_cep && ` — CEP ${exame.laboratorio_cep}`
                                                                            ]
                                                                                .filter(Boolean)
                                                                                .join('')}
                                                                        </p>
                                                                        <p className="mb-1"><strong>Telefone: </strong>
                                                                            {[
                                                                                exame.laboratorio_telefone,
                                                                                exame.laboratorio_telefone_2 && ` | ${exame.laboratorio_telefone_2}`,
                                                                                exame.laboratorio_telefone_3 && ` | ${exame.laboratorio_telefone_3}`
                                                                            ]
                                                                                .filter(Boolean)
                                                                                .join('')}
                                                                        </p>
                                                                        <p><strong>E-mail: </strong>
                                                                            {exame.laboratorio_email}
                                                                        </p>
                                                                    </Col>
                                                                </>
                                                            )}
                                                            {/* TODO: configurável por programa */}
                                                            <Col sm={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Check
                                                                        inline
                                                                        type="checkbox"
                                                                        label="Necessita de transporte?"
                                                                        key={`necessita_motorista_${index}`}
                                                                        id={`necessita_motorista_${index}`}
                                                                        name={`necessita_motorista_${index}`} // <- aqui também
                                                                        value={exame.necessita_motorista}
                                                                        onChange={e => this.handleChangeExameSolicitado(e, 'necessita_motorista', index)}
                                                                        checked={exame.necessita_motorista == true}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            {exame.necessita_motorista && preencherValorTransporte && (
                                                                <>
                                                                <Col sm={4}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>{transporteIdaVolta ? 'Valor do Transporte (Ida)' : 'Valor do Transporte'}</Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            name="motorista_orcamento"
                                                                            value={exame.motorista_orcamento || ''}
                                                                            onChange={e => this.handleChangeExameSolicitado(e, 'motorista_orcamento', index)}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                {transporteIdaVolta && (
                                                                <Col sm={4}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Valor do Transporte (Volta)</Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            name="motorista_orcamento_volta"
                                                                            value={exame.motorista_orcamento_volta || ''}
                                                                            onChange={e => this.handleChangeExameSolicitado(e, 'motorista_orcamento_volta', index)}
                                                                        />
                                                                        <Form.Text className="text-muted">Deixe em branco se não houver retorno.</Form.Text>
                                                                    </Form.Group>
                                                                </Col>
                                                                )}
                                                                </>
                                                            )}
                                                            {exame.necessita_motorista && (
                                                                <>
                                                                    <Col sm={12}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Responsável Transporte</Form.Label>
                                                                            <AsyncSelect
                                                                                key={this.state.exame_selecionado.exames_solicitados[index].focusMotorista}
                                                                                loadOptions={(inputValue) => {
                                                                                    return new Promise((resolve) => {
                                                                                        clearTimeout(this.state.exame_selecionado.exames_solicitados[index].motoristaSearchTimeout);
                                                                                        this.state.exame_selecionado.exames_solicitados[index].motoristaSearchTimeout = setTimeout(() => {
                                                                                            resolve(this.carregarMotoristas(inputValue, index));
                                                                                        }, 700);
                                                                                    });
                                                                                }}
                                                                                onFocus={() => {
                                                                                    this.setState({
                                                                                        exame_selecionado: { ...this.state.exame_selecionado, exames_solicitados: this.state.exame_selecionado.exames_solicitados.map((exame, i) => i === index ? { ...exame, focusMotorista: true } : exame) }
                                                                                    });
                                                                                }}
                                                                                //autoFocus={this.state.exame_selecionado.exames_solicitados[index].focusMotorista}
                                                                                openMenuOnFocus={this.state.exame_selecionado.exames_solicitados[index].focusMotorista}
                                                                                required
                                                                                defaultOptions
                                                                                onChange={e => this.handleChangeExameSolicitado(e, 'motorista_id', index)}
                                                                                value={exame.motorista_id ? { value: exame.motorista_id, label: exame.motorista_nome } : null}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                    {exame.motorista_id && (
                                                                    <Col sm={12}>
                                                                        <p><strong>Contato: </strong>{exame.motorista_contato}</p>
                                                                    </Col>
                                                                    )}
                                                                    {exame.motorista_id && !this.state.medico_logado_id && (
                                                                    <>
                                                                        {!preencherValorTransporte && (
                                                                            <Col sm={4}>
                                                                                <Form.Group className="mb-3">
                                                                                    <Form.Label>Valor do Transporte</Form.Label>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        name="motorista_orcamento"
                                                                                        value={exame.motorista_orcamento || ''}
                                                                                        onChange={e => this.handleChangeExameSolicitado(e, 'motorista_orcamento', index)}
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                        )}
                                                                        <Col sm={8}>
                                                                            <Form.Group className="mb-3">
                                                                                <Form.Label>Serviço de Transporte</Form.Label>
                                                                                <AsyncSelect
                                                                                    cacheOptions
                                                                                    defaultOptions
                                                                                    isClearable
                                                                                    placeholder="Selecione o serviço de transporte"
                                                                                    loadOptions={this.carregarServicosTransporte}
                                                                                    onChange={e => this.handleChangeExameSolicitado(e, 'servico_transporte_id', index)}
                                                                                    value={exame.servico_transporte_id ? { value: exame.servico_transporte_id, label: exame.servico_transporte_nome } : null}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={12} className="mb-3">
                                                                            <Button
                                                                                variant="success"
                                                                                size="sm"
                                                                                disabled={!exame.servico_transporte_id || !exame.motorista_orcamento}
                                                                                onClick={() => this.gerarAgendamentoTransporte(exame, index)}
                                                                            >
                                                                                Gerar agendamento do transporte
                                                                            </Button>
                                                                        </Col>
                                                                        {Array.isArray(exame.dados_agendamentos_transporte) && exame.dados_agendamentos_transporte.length > 0 && (
                                                                            <Col sm={12} className="mb-3">
                                                                                <Table responsive size="sm" className="custom-table">
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th>Transporte (serviço)</th>
                                                                                            <th>Responsável</th>
                                                                                            <th>Valor</th>
                                                                                            <th>Situação</th>
                                                                                            <th className="text-end">Faturamento</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {exame.dados_agendamentos_transporte.map(t => (
                                                                                            <tr key={t.id}>
                                                                                                <td>
                                                                                                    {t.servico_nome || '-'} <small className="text-muted">#{t.id}</small>
                                                                                                    {t.trecho && <span className="badge bg-light text-dark ms-2">{t.trecho === 'ida' ? 'Ida' : 'Volta'}</span>}
                                                                                                </td>
                                                                                                <td>{t.prestador_nome || '-'}</td>
                                                                                                {/* valor vem decimal da API; formatarValor espera string de centavos e exibia 280 como 2,80 */}
                                                                                                <td>{formatarValorLocal(t.valor)}</td>
                                                                                                <td>
                                                                                                    <span className={`badge-agendamento badge-status-${t.situacao}`}>
                                                                                                        {situacoesAgendamento[t.situacao] || t.situacao || '-'}
                                                                                                    </span>
                                                                                                </td>
                                                                                                <td className="text-end">
                                                                                                    {t.faturado
                                                                                                        ? <span className="badge bg-success me-2">Faturado</span>
                                                                                                        : <span className="badge bg-secondary me-2">Não faturado</span>}
                                                                                                    {/* mesma gestão da aba de Agendamentos, sem sair do pedido de exame */}
                                                                                                    {!['finalizado', 'cancelado'].includes(t.situacao) && (
                                                                                                        <>
                                                                                                            <Button variant="outline-success" size="sm" className="me-1"
                                                                                                                onClick={() => this.alterarSituacaoTransporte(t, exame, index, 'finalizado')}>
                                                                                                                Confirmar Realização
                                                                                                            </Button>
                                                                                                            <Button variant="outline-danger" size="sm"
                                                                                                                onClick={() => this.alterarSituacaoTransporte(t, exame, index, 'cancelado')}>
                                                                                                                Cancelar
                                                                                                            </Button>
                                                                                                        </>
                                                                                                    )}
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>
                                                                                </Table>
                                                                            </Col>
                                                                        )}
                                                                    </>
                                                                    )}
                                                                    {/*<Col sm={4}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Data de aprovação</Form.Label>
                                                                            <Form.Control type="datetime-local" name="motorista_data_aprovacao" required placeholder="Data de Aprovação" value={(exame.motorista_data_aprovacao && exame.motorista_data_aprovacao !== '1900-01-01T00:00:00') ? exame.motorista_data_aprovacao : ''} onChange={e => this.handleChangeExameSolicitado(e, 'motorista_data_aprovacao', index)} />
                                                                        </Form.Group>
                                                                    </Col>*/}
                                                                </>
                                                            )}
                                                            <Col sm={12} className="text-end">
                                                                <Button variant="secondary" size="sm" className="me-2" onClick={() => this.upsertExameSolicitado(exame)}>
                                                                    Atualizar Exame
                                                                </Button>
                                                                {hasPerm('delete_exames') && (
                                                                <Button variant="outline-danger" size="sm" className="me-2" onClick={() => this.excluirExameSolicitado(exame, this.state.exame_selecionado.exames_solicitados)}>
                                                                    Excluir Exame
                                                                </Button>
                                                                )}
                                                            </Col>
                                                        </>
                                                        )}
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                                );
                            })}
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary-outline" onClick={this.handleCloseModalExame}>
                            Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showModalPreSolicitacao} onHide={this.handleFecharPreSolicitacao} size="lg" enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>Solicitar {this.getConfigExames('nomenclatura', 'Exames')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            {!this.state.medico_logado_id && (
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Médico</Form.Label>
                                    <AsyncSelect
                                        key={this.state.focusMedico}
                                        loadOptions={(inputValue) => {
                                            return new Promise((resolve) => {
                                                clearTimeout(this.medicoSearchTimeout);
                                                this.medicoSearchTimeout = setTimeout(() => {
                                                    resolve(this.carregarMedicos(inputValue));
                                                }, 700);
                                            });
                                        }}
                                        onFocus={() => {
                                            this.setState({
                                                focusMedico: true
                                            });
                                        }}
                                        //autoFocus={this.state.focusMedico}
                                        openMenuOnFocus={this.state.focusMedico}
                                        required
                                        defaultOptions
                                        onChange={e => this.handleChangeExame(e, 'medico_id')}
                                        placeholder="Buscar médico..."
                                        noOptionsMessage={() => "Nenhum médico encontrado"}
                                        value={this.state.exame_selecionado.medico_id ? { value: this.state.exame_selecionado.medico_id, label: this.state.exame_selecionado.medico_nome } : null}
                                        isDisabled={this.state.exame_selecionado.status === 'realizado'}
                                    />
                                </Form.Group>
                            </Col>
                            )}
                            <Col sm={12} className="mb-3">
                                <Form.Label>Pedido de {this.getConfigExames('nomenclatura', 'Exames')} (.pdf,.doc,.docx,.jpg,.jpeg,.png) {dados_usuario['prestador_categoria'] === 'medicos' && <span className="text-danger">*</span>}</Form.Label>
                                <Form.Control
                                    type="file"
                                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                    onChange={this.onChangeArquivoPre}
                                />
                                {this.state.pre_arquivo_upload && (
                                <small className="text-muted d-block mt-1">
                                    Arquivo selecionado: {this.state.pre_arquivo_upload.name}
                                </small>
                                )}
                            </Col>

                            <Col sm={12}>
                                {/* 1. SELEÇÃO DO EXAME */}
                                <Form.Label>Selecione o {this.getConfigExames('nomenclatura', 'Exames')} <span className="text-danger">*</span></Form.Label>
                                
                                <div className="border rounded p-2" style={{maxHeight: 320, overflowY: 'auto'}}>
                                    {(() => {
                                        const listaFiltrada = this.state.listaExamesDisponiveis.filter(item => {
                                            if (item.ocultar_solicitacao_exames) return false;

                                            if (this.props.exames_extras_solicitacao && this.props.exames_extras_solicitacao.includes(item.id)) {
                                                return true;
                                            }

                                            const config = item.configuracoes || {};
                                            const regraOcultacao = config['oculta-selecao-on-solicitar-exames'];

                                            if (regraOcultacao && regraOcultacao['deny-profiles']) {
                                                const perfisNegados = regraOcultacao['deny-profiles'];
                                                
                                                const isMedico = dados_usuario['prestador_categoria'] === 'medicos';
                                                const isOperador = dados_usuario['tipo_usuario'] === 'operador';
                                                
                                                if (isMedico && perfisNegados.includes('medico')) return false;
                                                if (isOperador && perfisNegados.includes('operador')) return false;
                                            }
                                            return true;
                                        });

                                        if (listaFiltrada.length === 0) {
                                            return <p className="text-muted mb-0">Não há exames disponíveis para solicitação</p>;
                                        }

                                        return listaFiltrada.map(item => (
                                            <Form.Check
                                                key={item.id}
                                                type={this.props.habilitar_selecionar_multiplos_exames ? "checkbox" : "radio"}
                                                name="exame_pre"
                                                id={`exame_pre_${item.id}`}
                                                label={item.nome}
                                                checked={this.state.pre_examesSelecionados.has(item.id)}
                                                onChange={() => this.toggleExamePre(item.id)}
                                                className="mb-1"
                                            />
                                        ));
                                    })()}
                                </div>

                                {/* 2. RENDERIZAÇÃO DINÂMICA DOS FORMULÁRIOS */}
                                {(() => {
                                    const selecionados = Array.from(this.state.pre_examesSelecionados || []);
                                    
                                    if (selecionados.length === 0) return null;

                                    return selecionados.map((servicoId) => {
                                        const item = this.state.listaExamesDisponiveis.find(x => x.id === servicoId);
                                        const config = item?.configuracoes || {};
                                        const answers = this.state.respostasPorServico[servicoId] || {};
                                        const visibleQs = this.getVisibleQuestions(config, answers);

                                        // Se não houver perguntas visíveis, não renderiza o bloco
                                        if (visibleQs.length === 0) return null;

                                        return (
                                            <div key={servicoId} className="mt-3 border rounded p-3 bg-light">
                                                <h6 className="mb-3 text-primary">
                                                    <FaFileAlt className="me-2"/>
                                                    Informações adicionais: <strong>{item.nome}</strong>
                                                </h6>

                                                <Row>
                                                {this.renderQuestoesComSecoes(visibleQs, servicoId, answers)}
                                                </Row>
                                            </div>
                                        );
                                    });
                                })()}

                                {/* <Form.Label className="mt-4">Possui Kit para coleta?</Form.Label>
                                <div className="mb-2">
                                    <Form.Check
                                        inline type="radio" name="possuiKit" id="possuiKit_sim" label="Sim"
                                        checked={this.state.possuiKit === 'sim'}
                                        onChange={() => this.setState({ possuiKit: 'sim' })}
                                    />
                                    <Form.Check
                                        inline type="radio" name="possuiKit" id="possuiKit_nao" label="Não"
                                        checked={this.state.possuiKit === 'nao'}
                                        onChange={() => this.setState({ possuiKit: 'nao' })}
                                    />
                                </div> */}

                                {this.state.possuiKit === 'nao' && (
                                    <div className="mt-3 border rounded p-3">
                                        <h6 className="mb-3">Endereço para envio do Kit</h6>
                                        <Row>
                                            <Col sm={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Identificação do Local *</Form.Label>
                                                    <Form.Control
                                                        type="text" name="nome"
                                                        value={this.state.novoEndereco.nome}
                                                        onChange={this.handleChangeNovoEndereco}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col sm={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>CEP *</Form.Label>
                                                    <Form.Control
                                                        type="text" name="cep" inputMode="numeric" placeholder="Somente números"
                                                        value={this.state.novoEndereco.cep}
                                                        onChange={this.onChangeCepNovoEndereco}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col sm={8}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Endereço *</Form.Label>
                                                    <Form.Control
                                                        type="text" name="endereco"
                                                        value={this.state.novoEndereco.endereco}
                                                        onChange={this.handleChangeNovoEndereco}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col sm={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Número *</Form.Label>
                                                    <Form.Control
                                                        type="text" name="numero"
                                                        value={this.state.novoEndereco.numero}
                                                        onChange={this.handleChangeNovoEndereco}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col sm={9}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Complemento</Form.Label>
                                                    <Form.Control
                                                        type="text" name="complemento"
                                                        value={this.state.novoEndereco.complemento}
                                                        onChange={this.handleChangeNovoEndereco}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col sm={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Bairro *</Form.Label>
                                                    <Form.Control
                                                        type="text" name="bairro"
                                                        value={this.state.novoEndereco.bairro}
                                                        onChange={this.handleChangeNovoEndereco}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col sm={5}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Cidade *</Form.Label>
                                                    <Form.Control
                                                        type="text" name="cidade"
                                                        value={this.state.novoEndereco.cidade}
                                                        onChange={this.handleChangeNovoEndereco}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col sm={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>UF *</Form.Label>
                                                    <Form.Control
                                                        as="select" name="uf"
                                                        value={this.state.novoEndereco.uf}
                                                        onChange={this.handleChangeNovoEndereco}
                                                    >
                                                        <option value="">UF</option>
                                                        {Object.entries(this.ufOptions).map(([sigla, nome]) => (
                                                            <option key={sigla} value={sigla}>{sigla}</option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>
                                )}
                            </Col>       
                            {mensagemNovaSolicitacao && (                     
                            <Col sm={12}>
                                <Alert variant="info" className="p-2 mt-3">
                                    <FaInfoCircle className="me-2" /> <strong>IMPORTANTE!</strong><br />
                                    {mensagemNovaSolicitacao}
                                </Alert>
                            </Col>
                            )}
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" size="sm" onClick={this.handleFecharPreSolicitacao}>
                            Cancelar
                        </Button>
                        <Button variant="success" className="btn-sm" onClick={this.confirmarSolicitacaoExames} disabled={this.state.loading}>
                            {this.state.loading ? <span className="spinner-border spinner-border-sm" /> : `Adicionar Pedido de ${this.getConfigExames('nomenclatura', 'Exame')}`}
                        </Button>
                    </Modal.Footer>
                </Modal>

            </>
        )
    }
}

export default withRouter(ExamesComponent);
